import { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Api from '../api/api';
import Enums from '../../utilities/enum';
import Modal from 'react-bootstrap/Modal';
import { Tab, Nav, Fade, Button } from 'react-bootstrap'
import Loader from '../shared/loader';
import { useToasts } from 'react-toast-notifications'
import UploadFile from '../shared/file-uploader';
import RedactionPane from './_redactionPane';
import roleUtilities from '../../utilities/roleUtilities';
import arrayUtilities from '../../utilities/arrayUtilities';
import { ClientSiteTabbed } from '../allow-list/clientSiteTabbed';
import stringHelpers from '../../utilities/stringHelpers';
import { ErrorModal } from '../../utilities/errorModal';
import formUtilities from '../../utilities/formUtilities';
import { toDateTimeString, toInputFieldDateTimeString, toInputFieldDateString, isDateTimeElapsed, isToDateAfterFromDate, durationBetweenString, sortArrayOfObjectsByTimestampProperty, timeAgo, toDateString, toTimeString, areDatesEqual, dateRange } from '../../utilities/dateUtilities';
import { SearchSelect } from '../shared/searchSelect';
import Pagination from '../shared/pagination';
import OutstandingBalancePane from './_outstandingBalancePane';
import BreachOldLayout from './breachOldLayout';
import { TimeRangeSlider } from '../shared/timeRangeSlider';
import { renderValidity } from '../../utilities/allowListUtilities';
import imageUtilities from '../../utilities/imageUtilities';
import { DateRangePicker } from '../shared/dateRangePicker';
import { BreachAttachmentsDisplay } from '../shared/breachAttachmentsDisplay';
import { DateTimePickerWithCustomDisplay } from '../shared/dateTimePickerCustomDisplay';
import { MinutesInputWithUnit } from '../shared/minutesInputWithUnit';

var cloneDeep = require('lodash.clonedeep');
function Breach(props) {
    const isThirdPartyUser = roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) || roleUtilities.isThirdPartyManager(props.user, props.organisationId)
    const [navItems, setNavItems] = useState([
        {
            id: "allowed-list",
            label: "Allowed List",
            iconClass: "far fa-list-alt",
            badgeValue: null,
            isLoading: false,
        },
        {
            id: "contact-history",
            label: "Contact History",
            iconClass: "fas fa-phone",
            badgeValue: null,
            isLoading: false,
        },
        {
            id: "payments",
            label: "Payments",
            iconClass: "fas fa-coins",
            badgeValue: null,
            isLoading: false,
        },
        {
            id: "previous-contraventions",
            label: "Previous Contraventions",
            iconClass: "fas fa-history",
            badgeValue: null,
            isLoading: false,
        },
        {
            id: "attachments",
            label: "Attachments",
            iconClass: "fas fa-paperclip",
            badgeValue: null,
            isLoading: false,
        },
        {
            id: "notes",
            label: "Notes",
            iconClass: "far fa-sticky-note",
            badgeValue: null,
            isLoading: false,
        },
        {
            id: "appeals",
            label: "Appeals",
            iconClass: "fas fa-question-circle",
            badgeValue: null,
            isLoading: false,
        },
        {
            id: "transfer-of-liability",
            label: "Transfer of Liability",
            iconClass: "fas fa-exchange-alt",
            badgeValue: null,
            isLoading: false,
        },
        {
            id: "pcn-payments",
            label: "PCN Payments",
            iconClass: "far fa-money-bill-alt",
            badgeValue: null,
            isLoading: false,
        },
        {
            id: "additional-charges",
            label: "Additional Charges",
            iconClass: "fas fa-layer-group",
            badgeValue: null,
            isLoading: false,
        }
    ])
    const [timestamp, setTimestamp] = useState(new Date().getTime());
    const newLayoutPreferenceKey = `${props.user.id}-showNewLayoutPreference`
    const [showNewLayout, setShowNewLayout] = useState(stringHelpers.newLayoutPreference(newLayoutPreferenceKey))
    const [activeNavIndex, setActiveNavIndex] = useState("0")
    const [isLoading, setIsLoading] = useState(true);
    const [breachId, setBreachId] = useState(props.match.params.breachId)
    const [breach, setBreach] = useState(null);
    const [breaches, setBreaches] = useState(null);
    const [site, setSite] = useState(null);
    const [allocatedBreaches, setAllocatedBreaches] = useState(null);
    const [selectedSiteByClient, setSelectedSiteByClient] = useState(null)
    const [allowedVrms, setAllowedVrms] = useState(null);
    const [allowedVrmsSimilarityThreshold, setAllowedVrmsSimilarityThreshold] = useState(65);
    const [allowedVrmsPageNumber, setAllowedVrmsPageNumber] = useState(0);

    const [paymentsData, setPaymentsData] = useState(null)
    const [paymentsSimilarityThreshold, setPaymentsSimilarityThreshold] = useState(65);
    const [paymentsPageNumber, setPaymentsPageNumber] = useState(0);
    const [paymentsFromDate, setPaymentsFromDate] = useState(null);
    const [paymentsToDate, setPaymentsToDate] = useState(null);

    const [numberOfBreaches, setNumberOfBreaches] = useState(0);
    const [message, setMessage] = useState("");

    const [allContraventions, setAllContraventions] = useState(null);
    const [siteContraventions, setSiteContraventions] = useState(null);

    const [dupeTicket, setDupeTicket] = useState(null);
    const [vrm, setVrm] = useState("");
    const [contraventionId, setContraventionId] = useState(null);

    const [vehicleMake, setVehicleMake] = useState("");
    const [vehicleModel, setVehicleModel] = useState("");
    const [colour, setColour] = useState("");
    const [reference, setReference] = useState("");
    const [driverName, setDriverName] = useState("");
    const [driverMobileNumber, setDriverMobileNumber] = useState("");
    const [driverEmailAddress, setDriverEmailAddress] = useState("");
    const [blueBadgeNumber, setBlueBadgeNumber] = useState("");
    const [blueBadgeExpiryDate, setBlueBadgeExpiryDate] = useState("");
    const [maxStayMinutes, setMaxStayMinutes] = useState(null);
    const [noReturnWithinMinutes, setNoReturnWithinMinutes] = useState(null);
    const [typeDateTime, setTypeDateTime] = useState("0")
    const { firstDate, lastDate, displayString } = dateRange("currentDay")
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [reason, setReason] = useState("");
    const [canSave, setCanSave] = useState(false);
    const [siteGroups, setSiteGroups] = useState(null);
    const [siteGroup, setSiteGroup] = useState("");
    const [clients, setClients] = useState(null);
    const [clientId, setClientId] = useState("");
    const [tabActiveKey, setTabActiveKey] = useState("site");
    const [roi, setRoi] = useState(null);
    const [validOnlyOnSpecificDays, setValidOnlyOnSpecificDays] = useState(false)
    const [isValidMonday, setIsValidMonday] = useState(false)
    const [isValidTuesday, setIsValidTuesday] = useState(false)
    const [isValidWednesday, setIsValidWednesday] = useState(false)
    const [isValidThursday, setIsValidThursday] = useState(false)
    const [isValidFriday, setIsValidFriday] = useState(false)
    const [isValidSaturday, setIsValidSaturday] = useState(false)
    const [isValidSunday, setIsValidSunday] = useState(false)
    const [enabledFromTime, setEnabledFromTime] = useState("00:00:00")
    const [enabledToTime, setEnabledToTime] = useState("23:59:00")
    const [validOnlyAtSpecificTimes, setValidOnlyAtSpecificTimes] = useState(false)
    const [note, setNote] = useState("");
    const [reasons, setReasons] = useState(null);
    const [cancelReason, setCancelReason] = useState(null);
    const [canCancel, setCanCancel] = useState(false);
    const [contraventionValidation, setContraventionValidation] = useState(null)
    const [lookupDataInEdit, setLookupDataInEdit] = useState(false);
    const [lookupColour, setLookupColour] = useState("");
    const [lookupModel, setLookupModel] = useState("");
    const [lookupMake, setLookupMake] = useState("");
    const [ticketDetailsInEdit, setTicketDetailsInEdit] = useState(false)
    const [ticketDetailsLookupError, setTicketDetailsLookupError] = useState(null)
    const [observedFrom, setObservedFrom] = useState(null)
    const [observedTo, setObservedTo] = useState(null)
    const [duration, setDuration] = useState(null)
    const [attachments, setAttachments] = useState(null);
    const [deleteAttachmentId, setDeleteAttachmentId] = useState(null)
    const [contactDetailsList, setContactDetailsList] = useState(null);
    const [newContactUrl, setNewContactUrl] = useState("/");
    const [status, setStatus] = useState(null);
    const [showChangeStatus, setShowChangeStatus] = useState(false);
    const [appeals, setAppeals] = useState(null);
    const [transfers, setTransfers] = useState(null);
    const [previousContraventions, setPreviousContraventions] = useState(null);

    const [showAddPayment, setShowAddPayment] = useState(false);
    const [breachPayments, setBreachPayments] = useState(null);

    const [showAddCharge, setShowAddCharge] = useState(false)
    const [showDeleteCharge, setShowDeleteCharge] = useState(false)
    const [additionalCharges, setAdditionalCharges] = useState(null)
    const [additionalChargeId, setAdditionalChargeId] = useState(null)
    const [additionalChargeAmount, setAdditionalChargeAmount] = useState("")
    const [additionalChargeDescription, setAdditionalChargeDescription] = useState("")

    const [paymentAmount, setPaymentAmount] = useState("");
    const [paymentReference, setPaymentReference] = useState("");
    const [paymentNote, setPaymentNote] = useState("");
    const [canSavePayment, setCanSavePayment] = useState(false);

    const [breachPaymentId, setBreachPaymentId] = useState(null);
    const [showDeletePayment, setShowDeletePayment] = useState(false);

    const [prevUrl, setPrevUrl] = useState(null);
    const [nextUrl, setNextUrl] = useState(null);
    const [batchIndex, setBatchIndex] = useState(-1);
    const [batchLength, setBatchLength] = useState(-1);
    const [errorMessage, setErrorMessage] = useState(null);
    const [loadingVehicleLookup, setLoadingVehicleLookup] = useState(false)
    const [vehicleLookupError, setVehicleLookupError] = useState(null)
    const [successfulLookupVrm, setSuccessfulLookupVrm] = useState(null)
    const [showVoidModal, setShowVoidModal] = useState(false);
    const [showSlowDvlaResponseModal, setShowSlowDvlaResponseModal] = useState(false);
	const [voidNote, setVoidNote] = useState("");
    const [voidReasons, setVoidReasons] = useState(null)
    const [voidReason, setVoidReason] = useState("")
    const [isOnHoldExpiry, setIsOnHoldExpiry] = useState("")

    const { addToast } = useToasts();
    const history = useHistory();

    const [showAppeal, setShowAppeal] = useState(false);
    const [showTransfer, setShowTransfer] = useState(false);

    const handleCloseAppeal = () => setShowAppeal(false);
    const handleShowAppeal = () => setShowAppeal(true);
    const handleCloseTransfer = () => setShowTransfer(false);
    const handleShowTransfer = () => setShowTransfer(true);

    var _breachesAbortController = null;
    var _allocatedBreachesAbortController = null;

    const updateNavItemsLoading = (index, isLoading) => {
        setNavItems(prevState => prevState.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    isLoading: isLoading
                }
            }
            return item
        }))
    }

    const updateNavItemsBadge = (index, value) => {
        setNavItems(prevState => prevState.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    badgeValue: value,
                    isLoading: false,
                }
            }
            return item
        }))
    }

    const getBreachPayments = function () {
        updateNavItemsLoading(8, true)

        Api.getBreachPayments(
            (data) => {
                setBreachPayments(data);
                updateNavItemsBadge(8, data.length)
            },
            (error) => { console.log(error); updateNavItemsLoading(8, false) },
            breach.id,
            props.organisationId,
            props.token
        )
    };

    const savePayment = function () {

        updateNavItemsBadge(9, true)

        Api.addBreachPayment(
            () => {
                window.scrollTo(0, 0);
                getBreachPayments();
                getBreach()
            },
            (error) => { console.log(error); updateNavItemsBadge(9, false) },
            breach.id,
            paymentAmount,
            paymentReference,
            paymentNote,
            props.organisationId,
            props.token
        )

        setShowAddPayment(false);
    }

    const getReasons = function () {
        Api.getCancellationReasons(
            (data) => setReasons(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    };

    const getSiteContraventions = function (siteId) {
        Api.getSiteContraventions(
            (data) => {
                setSiteContraventions(data)
                if (arrayUtilities.isNullOrEmpty(data)) {
                    setContraventionValidation("This site has no contraventions configured")
                    setContraventionId(null)
                } else {
                    setContraventionValidation(null)
                }
            },
            (error) => console.log(error),
            props.organisationId,
            siteId,
            props.token
        )
    };

    const getAllContraventions = function () {
        Api.getContraventions(
            (data) => setAllContraventions(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    };

    const getAdditionalCharges = () => {
        updateNavItemsLoading(9, true)
        Api.getAdditionalCharges(
            data => {
                setAdditionalCharges(data)
                updateNavItemsBadge(9, data.length)
            },
            error => {
                console.log(error)
                updateNavItemsLoading(9, false)
            },
            breachId,
            props.organisationId,
            props.token
        )
    }

    const getPreviousContraventions = function () {
        if (vrm !== null && vrm !== "") {
            updateNavItemsLoading(3, true)
            Api.getBreaches(
                (data) => {
                    if (data && !arrayUtilities.isNullOrEmpty(data.items)) {
                        const previous = data.items.filter(x => x.id !== breachId)
                        setPreviousContraventions(previous)
                        updateNavItemsBadge(3, previous.length)
                    } else {
                        setPreviousContraventions([]);
                        updateNavItemsLoading(3, false)
                    }
                },
                (error) => { console.log(error); updateNavItemsLoading(3, false) },
                vrm, null, null, null, null, null, null, null, null, 0, 0, null, null, null,
                null, null,
                null,
                props.organisationId,
                props.token,
                null
            )
        }
    };

    const getBreach = function () {
        setIsLoading(true);
        Api.getBreach(
            (data) => {
                setBreach(data);
                updateNavItemsBadge(5, data.breachLogs.length)
                setContraventionId(data.contraventionId)
                setTimestamp(new Date().getTime());
                setSelectedSiteByClient(data.siteId)
                if (data.parkingSession?.entry && data.parkingSession?.exit) {
                    setObservedFrom(data.parkingSession.entry.timestamp)
                    setObservedTo(data.parkingSession.exit.timestamp)
                    setDuration(durationBetweenString(data.parkingSession.entry.timestamp, data.parkingSession.exit.timestamp))
                }
                Api.getSiteGroupsBySiteId(
                    props.organisationId, data.siteId,
                    result => setSiteGroups(result),
                    error => console.log(error),
                    props.token
                )
                setIsLoading(false);
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            breachId,
            props.organisationId,
            props.token
        )
    };

    const getAttachments = function () {
        updateNavItemsLoading(4, true)
        Api.getBreachAttachments(
            (data) => {
                let attachmentsData = []
                if (breach && !arrayUtilities.isNullOrEmpty(breach.emails)) {
                    attachmentsData = breach.emails.map(email => ({
                        ...email,
                        isEmail: true
                    }))
                }
                if (!arrayUtilities.isNullOrEmpty(data)) {
                    attachmentsData = [...attachmentsData, ...data]
                }
                const sortByTimestamp = sortArrayOfObjectsByTimestampProperty(attachmentsData)
                setAttachments(sortByTimestamp)
                updateNavItemsBadge(4, sortByTimestamp.length)
            },
            (error) => { console.log(error); updateNavItemsLoading(4, false) },
            props.organisationId,
            breachId, props.token
        )
    };

    const getBreaches = function () {
        if (_breachesAbortController) {
            _breachesAbortController.abort();
        }
        _breachesAbortController = new AbortController();
        const signal = _breachesAbortController.signal;
        Api.getBreaches(
            (data) => setBreaches(data.items),
            (error) => console.log(error),
            breach.vrm, null, null, null, null, null, null, null, null, 0, 0, null, null, null,
            null, null,
            null,
            props.organisationId,
            props.token,
            signal
        )
    };

    const getSite = function () {
        Api.getSite(
            (data) => setSite(data),
            () => { },
            breach.siteId, props.organisationId, props.token);
    }

    const ticketAction = function (content, toastType) {
        addToast(content, {
            appearance: toastType,
            autoDismiss: true,
        })
    };

    const getAllowedVrms = function (page) {
        updateNavItemsLoading(0, true)
        if (!stringHelpers.isNullOrEmpty(vrm)) {
            Api.searchAllowedVrms(
                (data) => {
                    updateNavItemsBadge(0, data.totalCount)
                    setAllowedVrms(data);
                },
                (error) => {
                    console.log(error);
                    updateNavItemsLoading(0, false)
                },
                1, page, "", vrm, null, null, allowedVrmsSimilarityThreshold / 100, site.id, 0, null, 0, null, null, null, false, null,
                props.organisationId, props.token, true
            )
        }
    };

    const onAllowedVrmSimilarityThresholdChanged = function () {
        setTimeout(() => {
            setAllowedVrmsPageNumber(0)
            getAllowedVrms(0);
        }, 250);
    };

    const changePageNumberAllowedVrms = function (num) {
        setAllowedVrmsPageNumber(num);
        getAllowedVrms(num)
    };

    const fetchPaymentsData = (page, similarityThreshold) => {
        updateNavItemsLoading(2, true)

        Api.getPaymentsData(
            data => {
                setPaymentsData(data);
                updateNavItemsBadge(2, data.totalCount)
            },
            () => updateNavItemsLoading(2, false),
            vrm, site.id, paymentsFromDate, paymentsToDate, page, parseFloat(similarityThreshold / 100), 0, 1, null, props.organisationId, props.token
        )
    }

    const changePaymentsSimilarityThresholdTimeout = useRef();
    const changePaymentsSimilarityThreshold = function (x) {

        setPaymentsSimilarityThreshold(Number(x));

        if (changePaymentsSimilarityThresholdTimeout.current) {
            clearTimeout(changePaymentsSimilarityThresholdTimeout.current);
            changePaymentsSimilarityThresholdTimeout.current = null;
        }

        changePaymentsSimilarityThresholdTimeout.current = setTimeout(() => {
            fetchPaymentsData(paymentsPageNumber, Number(x));
        }, 1000);
    };

    const changePaymentsPageNumber = (num) => {
        setPaymentsPageNumber(num)
        fetchPaymentsData(num, paymentsSimilarityThreshold);
    }


    const voidTicket = function () {
        Api.voidTicket(
            () => {
                setShowVoidModal(false)
                getBreach();
                addToast("Ticket Voided Successfully", {
                    appearance: 'error',
                    autoDismiss: true,
                });
                autoShowNextBreach();
            },
            (error) => console.log(error),
            breachId,
            !stringHelpers.isNullOrEmpty(voidReason) ? voidReason : null, 
            !stringHelpers.isNullOrEmpty(note) ? note : "ticket voided",
            props.organisationId,
            props.token);

    };

    const setOnHold = function (onHold) {
        Api.onHoldTicket(
            () => {
                getBreach();
                setMessage("")
                setIsOnHoldExpiry("")
                if (onHold) {
                    autoShowNextBreach()
                }
            },
            (error) => console.log(error),
            message,
            breachId,
            onHold,
            !stringHelpers.isNullOrEmpty(isOnHoldExpiry) ? isOnHoldExpiry : null,
            props.organisationId,
            props.token
        )
    };

    const submit = function () {
        if (canSave) {
            Api.addAllowedVrm(
                data => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                    } else {
                        voidTicket()
                    }
                },
                (error) => {
                    setErrorMessage(error.errorMessage)
                },
                vrm,
                vehicleMake,
                vehicleModel,
                colour,
                reference,
                driverName,
                driverMobileNumber,
                stringHelpers.isNullOrEmpty(startDate) ? null : new Date(startDate).toISOString(),
                stringHelpers.isNullOrEmpty(endDate) ? null : new Date(endDate).toISOString(),
                validOnlyAtSpecificTimes ? enabledFromTime + ':00' : null,
                validOnlyAtSpecificTimes ? enabledToTime + ':00' : null,
                isValidMonday,
                isValidTuesday,
                isValidWednesday,
                isValidThursday,
                isValidFriday,
                isValidSaturday,
                isValidSunday, 
                reason,
                ((tabActiveKey === "global" || tabActiveKey === "client") || stringHelpers.isNullOrEmpty(breach.parkingSession.siteId)) ? null : breach.parkingSession.siteId,
                ((tabActiveKey === "global" || tabActiveKey === "site") || stringHelpers.isNullOrEmpty(clientId)) ? null : clientId,
                null,
                roi,
                !stringHelpers.isNullOrEmpty(siteGroup) ? siteGroup : null,
                !stringHelpers.isNullOrEmpty(blueBadgeNumber) ? blueBadgeNumber : null,
                !stringHelpers.isNullOrEmpty(blueBadgeExpiryDate) ? blueBadgeExpiryDate : null,
                maxStayMinutes,
                noReturnWithinMinutes,
                props.organisationId,
                props.token
            );
        }
    };

    const getClients = () => {
        Api.getClients(
            data => setClients(data),
            error => console.log(error),
            props.organisationId,
            props.token
        )
    }

    const sendToDvla = function () {
        const timeout = setTimeout(() => {
            setIsLoading(false)
            setShowSlowDvlaResponseModal(true);
        }, 20000)

        setIsLoading(true)
        
        Api.sendTicketToDvla(
            data => {
                clearTimeout(timeout)
                setIsLoading(false)
                setShowSlowDvlaResponseModal(false);
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getBreach();
                    ticketAction("DVLA requested", 'info');
                    autoShowNextBreach()
                }
            },
            (error) => {
                clearTimeout(timeout)
                setIsLoading(false)
                setErrorMessage(error.errorMessage)
                setShowSlowDvlaResponseModal(false)
                ticketAction(error, 'error')
            },
            props.organisationId,
            breachId,
            props.token
        )

        return clearTimeout(timeout)        
    };

    const attachFile = function (file) {
        Api.addBreachAttachment(
            () => getAttachments(),
            file.id, breachId, props.organisationId, props.token
        )
    };

    const getAllocatedBreaches = function () {
        if (_allocatedBreachesAbortController) {
            _allocatedBreachesAbortController.abort();
        }
        _allocatedBreachesAbortController = new AbortController();
        const signal = _allocatedBreachesAbortController.signal;
        Api.getBreaches(
            (data) => setAllocatedBreaches(data.items),
            (error) => console.log(error),
            null, null, props.user.id, true, null, null, null, null, null, 0, 0, null, null, null,
            null, null,
            null,
            props.organisationId,
            props.token,
            signal
        )
    };

    const submitNote = function () {
        if (!stringHelpers.isNullOrEmpty(note)) {
            Api.attachNoteToTicket(
                () => {
                    getBreach();
                    setNote(null);
                },
                (error) => console.log(error),
                note, breachId,
                props.organisationId,
                props.token
            )
        }
    };

    const getAppeals = function () {
        updateNavItemsLoading(6, true)
        Api.getAppeals(
            (data) => {
                setAppeals(data)
                updateNavItemsBadge(6, data.length)
            },
            (error) => { console.log(error); updateNavItemsLoading(6, false) },
            breachId,
            props.organisationId,
            props.token
        )
    };

    const editBreach = function (selectedSite) {
        setIsLoading(true)
        const isMnpr = allContraventions?.find(x => x.id === contraventionId)?.contraventionType === 1
        Api.editBreach(
            (data) => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    setSelectedSiteByClient(data.siteId)
                    getSiteContraventions(data.siteId)
                    setBreach(data);
                    setContraventionId(data.contraventionId)
                    setLookupDataInEdit(false);
                    setTicketDetailsInEdit(false)
                    setDuration(
                        durationBetweenString(data.parkingSession?.entry?.timestamp, data.parkingSession?.exit?.timestamp)
                    )
                }
                setIsLoading(false)
            },
            error => { 
                setErrorMessage(error.errorMessage); 
                setIsLoading(false) 
            },
            vrm, lookupMake, lookupModel, lookupColour, contraventionId, breachId, selectedSite, isMnpr ? new Date(observedFrom).toISOString() : null, isMnpr ? new Date(observedTo).toISOString() : null, props.organisationId, props.token
        )
    };

    const getTransfers = function () {
        updateNavItemsLoading(7, true)
        Api.getTransfersLiability(
            (data) => {
                setTransfers(data)
                updateNavItemsBadge(7, data.length)
            },
            (error) => { console.log(error); updateNavItemsLoading(7, false) },
            breachId,
            props.organisationId,
            props.token
        )
    };

    const cancelTicket = function () {
        if (canCancel) {
            Api.cancelTicket(
                () => {
                    getBreach();
                    ticketAction('Ticket Cancelled Successfully', 'error');
                    autoShowNextBreach()
                },
                (error) => console.log(error),
                cancelReason.id,
                props.organisationId,
                breachId,
                props.token
            )
        }
    };

    const readyForLetters = function () {
        if (contactDetailsList.length !== 0) {
            Api.setReadyForLetters(
                (data) => {
                    getBreach();
                },
                (error) => console.log(error),
                "", breachId, props.organisationId, props.token
            )
        }
    };

    const getContactDetails = function () {
        updateNavItemsLoading(1, true)
        Api.getAllContacts(
            (data) => {
                setContactDetailsList(data)
                updateNavItemsBadge(1, data.length)
            },
            (error) => { console.log(error); updateNavItemsLoading(1, false) },
            breachId, props.organisationId, props.token
        )
    };

    const cancelChangeStatus = function () {
        setStatus(breach.breachStatus);
        setNote(null);
        setShowChangeStatus(false);
    };

    const changeStatus = function () {
        setShowChangeStatus(false);

        Api.setBreachStatus(
            () => {
                getBreach();
                setNote(null);
            },
            (error) => console.log(error),
            note,
            breachId,
            status,
            props.organisationId,
            props.token
        )
    };

    const onSaveReducedCharge = function (reducedChargeDays, reducedChargeAmount) {
        setIsLoading(true);

        Api.setBreachReducedCharge(
            () => {
                getBreach();
            },
            (error) => console.log(error),
            breachId,
            reducedChargeDays,
            reducedChargeAmount,
            props.organisationId,
            props.token
        );
    }

    useEffect(() => {
        if (breach !== null) {
            setVrm(breach.vrm);
            setStatus(breach.breachStatus);

            if (breaches && breaches !== null && breaches.length > 0) {
                var total = 0;

                breaches.forEach(item => {
                    if (item.vrm === breach.vrm) {
                        total++;
                        if (areDatesEqual(item.timestamp, breach.timestamp) && item.id !== breach.id) {
                            setDupeTicket(item)
                        }
                    }
                });
                setNumberOfBreaches(total);
            }
            const breachDate = new Date(breach.timestamp);
            const toDate = new Date(Date.UTC(breachDate.getFullYear(), breachDate.getMonth(), breachDate.getDate() + 1, 23, 59, 59));
            const fromDate = new Date(Date.UTC(breachDate.getFullYear(), breachDate.getMonth(), breachDate.getDate() - 1, 0, 0, 0));
            setPaymentsToDate(toDate)
            setPaymentsFromDate(fromDate)
        } else {
            getBreach();
        }
    }, [breach, breaches]);

    useEffect(() => {
        if (vrm !== null) {
            setVrm(vrm.toUpperCase());
            if (site !== null && !lookupDataInEdit) {
                getAllowedVrms(0)
                fetchPaymentsData(0, paymentsSimilarityThreshold)
            }
        }
    }, [vrm, site]);

    useEffect(() => {
        if (site !== null && !lookupDataInEdit) {
            fetchPaymentsData(0, paymentsSimilarityThreshold)
        }
    }, [paymentsFromDate, paymentsToDate])

    const addNewAppeal = function () {
        history.push("/organisation/" + props.organisationId + "/breach/" + breachId + "/appeal");
    };

    const deleteAppeal = function (appealId) {
        Api.deleteAppeal(() => {
            getBreach();
        }, () => {
            alert("Error deleting appeal");
        }, breachId, appealId, props.organisationId, props.token);
    }

    const addNewTransfer = function () {
        history.push("/organisation/" + props.organisationId + "/breach/" + breachId + "/transfer-of-liability");
    };

    const attachmentIsLetterImage = function (attachmentId, isLetterImage) {
        let attachmentsClone = cloneDeep(attachments);
        let targetIndex = attachmentsClone.findIndex(x => x.id === attachmentId);

        if (targetIndex >= 0) {
            attachmentsClone[targetIndex].isLetterImage = isLetterImage;
        }

        setAttachments(attachmentsClone);
        Api.setBreachAttachmentIsLetterImage(() => {

        }, () => {

        }, props.organisationId, props.id, attachmentId, isLetterImage, props.token)
    }

    useEffect(() => {
        if (!isLoading && breach && breach !== null && status !== breach.breachStatus) {
            if (status === 200) {
                handleShowAppeal();
            } else if (status === 210) {
                handleShowTransfer();
            } else {
                setShowChangeStatus(true);
            }
        }
    }, [status]);

    useEffect(() => {
        if (cancelReason !== null) {
            setCanCancel(true);
        } else {
            setCanCancel(false);
        }
    }, [cancelReason]);

    useEffect(() => {
        setBreachId(props.match.params.breachId);
    }, [props.match.params.breachId])

    useEffect(() => {
        if (!arrayUtilities.isNullOrEmpty(allocatedBreaches) && breachId !== null) {

            setBatchLength(allocatedBreaches.length);

            let index = allocatedBreaches.findIndex(x => x.id === breachId);

            if (index > -1) {

                setBatchIndex(index);
                if (index !== 0) {
                    setPrevUrl("/organisation/" + props.organisationId + "/breach/" + allocatedBreaches[index - 1].id);
                } else {
                    setPrevUrl("/organisation/" + props.organisationId + "/breach/" + allocatedBreaches[allocatedBreaches.length - 1].id);
                }
                if (index !== allocatedBreaches.length - 1) {
                    setNextUrl("/organisation/" + props.organisationId + "/breach/" + allocatedBreaches[index + 1].id);
                } else {
                    setNextUrl("/organisation/" + props.organisationId + "/breach/" + allocatedBreaches[0].id);
                }
            } else {
                setPrevUrl(null);
                setNextUrl(null);
            }
        } else {
            setPrevUrl(null);
            setNextUrl(null);
        }
    }, [allocatedBreaches]);

    useEffect(() => {
        if (breachId !== null) {
            getBreach();
            setNewContactUrl("/organisation/" + props.organisationId + "/breach/" + breachId + "/contact-details");
        }
        getAllContraventions();
        getReasons();
    }, [breachId]);

    useEffect(() => {
        if (breach !== null) {
            if (breach.vehicleMake !== null) {
                setLookupMake(breach.vehicleMake);
            } else {
                setLookupMake(null);
            }
            if (breach.vehicleColour !== null) {
                setLookupColour(breach.vehicleColour);
            } else {
                setLookupColour(null);
            }
            if (breach.vehicleModel !== null) {
                setLookupModel(breach.vehicleModel);
            } else {
                setLookupModel(null);
            }
        }
    }, [lookupDataInEdit, breach]);

    const reloadImages = function () {
        getBreach();
    };

    const getVoidReasons = () => {
        Api.getVoidReasons(
            (data) => setVoidReasons(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    }

    useEffect(() => {
        if (breach !== null) {
            getBreaches();
            getSite();
            getSiteContraventions(breach.siteId);
            getBreachPayments();
            getAdditionalCharges()
        }
        getAppeals();
        getAttachments();
        getContactDetails();
        getPreviousContraventions();
        getTransfers();
    }, [breach]);

    useEffect(() => {
        if (!stringHelpers.isValidVrm(vrm) || !isToDateAfterFromDate(startDate, endDate)) {
            setCanSave(false);
        } else {
            setCanSave(true);
        }
    }, [startDate, endDate, vrm]);

    useEffect(() => {
        getAllocatedBreaches();
        getClients();
        if (!stringHelpers.isNullOrEmpty(vrm) && site && site !== null) {
            getAllowedVrms(0)
        }
        getVoidReasons()
    }, []);

    useEffect(() => {
        setCanSavePayment(!isNaN(paymentAmount) && paymentAmount > 0 && !stringHelpers.isNullOrEmpty(paymentReference));
    }, [paymentAmount, paymentReference]);

    useEffect(() => {
        setPaymentAmount("");
        setPaymentReference("");
        setPaymentNote("");
    }, [showAddPayment])

    const autoShowNextBreach = () => {
        if (!stringHelpers.isNullOrEmpty(nextUrl)) {
            console.log(nextUrl)
            history.push(nextUrl)
        }
    }

    const isBreachActionsDisabled = (breachAssignedId) => !stringHelpers.isNullOrEmpty(breachAssignedId) && breachAssignedId !== props.user.id

    const vehicleLookup = () => {
        setLoadingVehicleLookup(true)
        Api.vehicleLookup(
            data => {
                if (data.isError) {
                    setVehicleLookupError(data.errorMessage)
                } else {
                    setVehicleMake(data.vehicleMake)
                    setVehicleModel(data.vehicleModel)
                    setColour(data.vehicleColour)
                    setSuccessfulLookupVrm(vrm)
                    setVehicleLookupError(null)
                }
                setLoadingVehicleLookup(false)
            },
            () => {
                setVehicleLookupError("Unable to find vehicle details")
                setLoadingVehicleLookup(false)
            },
            vrm.toLowerCase(),
            props.organisationId, props.token
        )
    }

    const saveAdditionalCharge = () => {
        if (additionalChargeId) {
            Api.editAdditionalCharge(
                data => {
                    if (data.isError) {
                        setShowAddCharge(false)
                        setErrorMessage(data.errorMessage)
                    } else {
                        setShowAddCharge(false)
                        getAdditionalCharges()
                        getBreach()
                    }
                },
                error => {
                    setShowAddCharge(false)
                    setErrorMessage(error.message)
                },
                breachId, additionalChargeId, additionalChargeAmount, additionalChargeDescription,
                props.organisationId, 
                props.token
            )
        } else {
            Api.addAdditionalCharge(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    setShowAddCharge(false)
                    setAdditionalChargeAmount("")
                    setAdditionalChargeDescription("")
                    getAdditionalCharges()
                    getBreach()
                }
            },
            error => {
                console.log(error)
                setShowAddCharge(false)
                setErrorMessage(error.message)
            }, 
            breachId, Number(additionalChargeAmount), additionalChargeDescription,
            props.organisationId,
            props.token
        )
        }
    }

    const breachStatusOptionsByRole = () => {
        const thirdPartyAllowedStatuses = ["220", "221", "222", "223", "224", "225", "308", "321", "322"]
        const allOptions = Object.entries(Enums.BreachStatus)
        const options = (isThirdPartyUser || roleUtilities.isOrganisationProcessor(props.user, props.organisationId))
            ? allOptions
                .filter(([key]) => (thirdPartyAllowedStatuses.includes(key)))
            : allOptions
            
        if (options.findIndex(item => item[0] === String(status)) === -1) {
            options.push([String(status), Enums.BreachStatus[status]])
        }
        return options.map(([key, value]) => ({value: key, label: value}))
    }

    const imageAttachments = attachments
        ? attachments.filter(attachment => attachment.isImage).map(attachment => ({ ...attachment, url: attachment.url + '&ts=' + timestamp }))
        : [];

    return (
        <>
            { isLoading &&
                <Loader />
            }
            { !isLoading && breach && breach !== null && <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mb-2 breach-header">
                                <div className="card-header ">
                                    <div className="row align-items-center justify-content-between ">
                                        <div className="col d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0 d-flex align-items-center">
                                                { !stringHelpers.isNullOrEmpty(prevUrl) &&
                                                    <Link className="btn btn-sm mr-1" to={ prevUrl }><i className="fas fa-2x fa-angle-left"></i></Link> }
                                                Breach -
                                                { breach.referenceNumber !== null && <> { breach.referenceNumber }</> }
                                                { breach.referenceNumber === null && <p className="small-number-plate m-0 ml-2"> { breach.vrm }</p> }
                                                { batchIndex > -1 && batchLength > 0 && <>&nbsp;({ batchIndex + 1 } of { batchLength })</> }
                                                { !stringHelpers.isNullOrEmpty(nextUrl) &&
                                                    <Link className="btn btn-sm" to={ nextUrl }><i className="fas fa-2x fa-angle-right"></i></Link> }
                                            </h5>
                                        </div>
                                        <div className="col-auto text-right pl-0 filter-buttons-wrapper">
                                            <div className='d-flex gap-1 align-items-center'>
                                                <small>Show new layout (beta)</small>
                                                <div className="custom-control custom-switch">
                                                <input className="custom-control-input" type="checkbox" id="contraventions-for-overstay-enabled" checked={ showNewLayout } onChange={ e => {
                                                    localStorage.setItem(newLayoutPreferenceKey, e.target.checked);
                                                    setShowNewLayout(!showNewLayout)
                                                    window.scrollTo(0, 0);
                                                } } />
                                                <label className="custom-control-label custom-toggle ml-2" htmlFor="contraventions-for-overstay-enabled"></label>
                                            </div>
                                            </div>
                                            <button className="btn btn-default btn-sm ml-1" onClick={ getBreach }><i className="fas fa-redo"></i> Refresh</button>
                                            { breach.breachStatus === 400 &&
                                                <button className="btn btn-success btn-sm ml-1" onClick={ () => setStatus(402) }><i className="fas fa-play"></i> Send to debt recovery</button>
                                            }
                                            { !breach.isCurrentlyOnHold &&
                                                <button disabled={ isBreachActionsDisabled(breach.assignedToUserId) } className="btn btn-primary btn-sm ml-1" data-toggle="modal" data-target="#on-hold-modal"><i className="fas fa-pause"></i> Place on Hold</button>
                                            }
                                            { breach.isCurrentlyOnHold &&
                                                <button disabled={ isBreachActionsDisabled(breach.assignedToUserId) } className="btn btn-primary btn-sm ml-1" onClick={ () => setOnHold(false) }><i className="fas fa-play"></i> Take off Hold</button>
                                            }
                                            { breach.breachStatus === 0 && !isThirdPartyUser &&
                                                <button disabled={ isBreachActionsDisabled(breach.assignedToUserId) } className="btn btn-primary btn-sm ml-1" onClick={ () => sendToDvla() }><i className="fas fa-wrench"></i> DVLA Request</button> }

                                            { breach.breachStatus !== 0 &&
                                                <button disabled={ isBreachActionsDisabled(breach.assignedToUserId) } className="btn btn-danger btn-sm ml-1" data-toggle="modal" data-target="#cancel-modal"><i className="fas fa-times"></i> Cancel Ticket</button> }

                                            { breach.breachStatus === 0 && !roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) &&
                                                <button disabled={ isBreachActionsDisabled(breach.assignedToUserId) } className="btn btn-danger btn-sm ml-1" onClick={ () => setShowVoidModal(true) }><i className="fas fa-times"></i> Void Ticket</button> }

                                            {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <button disabled={ isBreachActionsDisabled(breach.assignedToUserId) } className="btn btn-success btn-sm ml-1" data-toggle="modal" data-target="#allow-list-modal"><i className="fas fa-plus"></i> Add to Allow List</button>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`mb-3 mt-5 ${showNewLayout ? "px-3" : "px-0"}`}>
                                <div className="modal fade" id="cancel-modal" tabIndex="-1" role="dialog" aria-labelledby="Cancel Modal" aria-hidden="true">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="deleteModalLabel">Select a reason to cancel this ticket.</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="row">
                                                    <div className="col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-2">Reason:</p>
                                                    </div>
                                                    <div className="col-12 ">
                                                        <div className="form-group mb-0">
                                                            <div className="dropdown ">
                                                                <button className="btn btn-falcon-default dropdown-toggle btn-sm mb-1 edit-dropdown" id="select-type" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{ cancelReason !== null && cancelReason.name }{ cancelReason === null && <>Select Reason</> }</button>
                                                                <div className="dropdown-menu py-0 edit-dropdown" aria-labelledby="select-type" >
                                                                    <div className="bg-white py-2 rounded-soft">
                                                                        { reasons !== null && reasons.map((reason) => {
                                                                            return (
                                                                                <button className="dropdown-item text-base px-3 py-2" onClick={ () => setCancelReason(reason) }>{ reason.name }</button>
                                                                            )
                                                                        }) }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                <button type="button" className="btn btn-success btn-sm ml-2" disabled={ !canCancel } data-dismiss="modal" onClick={ () => cancelTicket() }>
                                                    Confirm</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal fade" id="on-hold-modal" tabIndex="-1" role="dialog" aria-labelledby="On Hold Modal" aria-hidden="true">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="deleteModalLabel">Add a note to place this ticket On Hold.</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="row align-items-center">
                                                    <div className="col-12 ">
                                                        <p className="font-weight-semi-bold mt-1 mb-2">Expiry Date</p>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="form-group mb-1">
                                                            <input className="form-control mb-0" type="date" value={ stringHelpers.isNullOrEmpty(isOnHoldExpiry) ? null : isOnHoldExpiry } onChange={ (e) => setIsOnHoldExpiry(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-2">Note:</p>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="form-group mb-0">
                                                            <textarea className="form-control mb-0" rows={ 4 } value={ message } onChange={ (e) => setMessage(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                <button disabled={ stringHelpers.isNullOrEmpty(message) } type="button" className="btn btn-success btn-sm ml-2" data-dismiss="modal" onClick={ () => setOnHold(true) }>
                                                    Confirm</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Modal show={ showSlowDvlaResponseModal } backdrop="static" keyboard={ false } centered>
                                    <Modal.Header>
                                        <Modal.Title>Information</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className='info-widget d-flex flex-column align-items-center'>
                                        <p className="font-weight-semi-bold mt-1 mb-3">
                                            This is taking longer than usual - waiting for Transfer 360 response.
                                        </p>
                                        {
                                            isLoading && 
                                            <div className='tiny-loader'>
                                                <Loader />
                                            </div>
                                        }
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button onClick={() => setShowSlowDvlaResponseModal(false)} variant='secondary'>Dismiss</Button>
                                    </Modal.Footer>
                                </Modal>
                                <Modal show={ showChangeStatus } onHide={ cancelChangeStatus } size="lg">
                                    <Modal.Header>
                                        <Modal.Title>
                                            Add a note to set status to { Enums.BreachStatus[status] }
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="row">
                                            <div className="col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-2">Note:</p>
                                            </div>
                                            <div className="col-12">
                                                <div className="form-group mb-0">
                                                    <textarea className="form-control mb-0" rows={ 4 } value={ note } onChange={ (e) => setNote(e.target.value) } />
                                                </div>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button className="btn btn-sm btn-danger mt-1" onClick={ cancelChangeStatus }>Cancel</button>
                                        <button className="btn btn-sm btn-success mt-1" disabled={ stringHelpers.isNullOrEmpty(note) } onClick={ changeStatus }>Confirm</button>
                                    </Modal.Footer>
                                </Modal>
                                <Modal show={ showAppeal } onHide={ handleCloseAppeal }>
                                    <Modal.Header>
                                        <Modal.Title>
                                            <div className="row justify-content-between">
                                                <div className="col-11">
                                                    Do you want to add a new Appeal?
                                                </div>
                                                <div className="col-1">
                                                    <button type="button" className="close" onClick={ handleCloseAppeal }>
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Footer>
                                        <button className="btn btn-sm btn-danger mt-1" onClick={ () => { handleCloseAppeal(); setStatus(breach.breachStatus); } }>Cancel</button>
                                        <button className="btn btn-sm btn-success mt-1" onClick={ () => { handleCloseAppeal(); addNewAppeal(); } }>Confirm</button>
                                    </Modal.Footer>
                                </Modal>
                                <Modal show={ showTransfer } onHide={ handleCloseTransfer }>
                                    <Modal.Header>
                                        <Modal.Title>
                                            <div className="row justify-content-between">
                                                <div className="col-11">
                                                    Do you want to add a new Transfer of Liability?
                                                </div>
                                                <div className="col-1 text-right">
                                                    <button type="button" className="close" onClick={ handleCloseTransfer }>
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Footer>
                                        <button className="btn btn-sm btn-danger mt-1" onClick={ () => { handleCloseTransfer(); setStatus(breach.breachStatus); } }>Cancel</button>
                                        <button className="btn btn-sm btn-success mt-1" onClick={ () => { handleCloseTransfer(); addNewTransfer(); } }>Confirm</button>
                                    </Modal.Footer>
                                </Modal>
                                {
                                    showVoidModal &&
                                    <Modal show onHide={ () => { setShowVoidModal(false); setVoidReason(""); setNote("") } }>
                                        <Modal.Header>
                                            <Modal.Title>Void breach.</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div className="row mb-2">
                                                <div className="col-12 ">
                                                    <p className="font-weight-semi-bold  mt-1 mb-1">Reason:</p>
                                                </div>
                                                <div className="col-12">
                                                    <div className="form-group mb-0">
                                                        <select
                                                            id="void-reason-selector"
                                                            className="border rounded py-1 px-2 w-100"
                                                            onChange={ (e) => setVoidReason(e.target.value) }
                                                            value={ voidReason }
                                                        >
                                                            <option value="">Select a reason</option>
                                                            { voidReasons?.map(item => <option value={ item.id }>{ item.name }</option>) }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 ">
                                                    <p className="font-weight-semi-bold  mt-1 mb-2">Note:</p>
                                                </div>
                                                <div className="col-12">
                                                    <div className="form-group mb-0">
                                                        <textarea className="form-control mb-0" rows={ 4 } value={ note } onChange={ (e) => setNote(e.target.value) } />
                                                    </div>
                                                </div>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <button
                                                className="btn btn-sm btn-danger mt-1"
                                                onClick={ () => { setShowVoidModal(false); setVoidReason(""); setNote("") } }
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className="btn btn-sm btn-success mt-1"
                                                onClick={ () => voidTicket() }
                                            >
                                                Confirm
                                            </button>
                                        </Modal.Footer>
                                    </Modal>
                                }
                                <div className="modal fade allow-list-modal" id="allow-list-modal" tabIndex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="deleteModalLabel">Add to Allow List</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <h6 className="mb-3 fs-1">Vehicle Details</h6>
                                                <div className="row">
                                                    <div className="col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-1 text-left">VRM<span className="req"></span></p>
                                                    </div>
                                                    <div className="col-md-8 col-12 ">
                                                        <div className='d-flex align-items-start'>
                                                            <div className="form-group mb-1">
                                                                <input disabled={ loadingVehicleLookup } required className="form-control mb-1 small-number-plate" type="text" value={ vrm } onChange={ (e) => {
                                                                    if (!stringHelpers.isNullOrEmpty(vehicleLookupError)) {
                                                                        setVehicleLookupError(null)
                                                                    }
                                                                    setVrm(e.target.value.toUpperCase());
                                                                    formUtilities.requiredField(e.target.parentNode, e.target.value)
                                                                } } />
                                                                <small className='invalid-feedback text-danger'>Please enter a VRM</small>

                                                                {
                                                                    !stringHelpers.isNullOrEmpty(vrm) &&
                                                                    <small className='text-danger'>
                                                                        {
                                                                            !stringHelpers.isValidVrm(vrm)
                                                                                ? <>Invalid VRM format</>
                                                                                : !stringHelpers.isNullOrEmpty(vehicleLookupError) && vehicleLookupError
                                                                        }
                                                                    </small>
                                                                }
                                                            </div>
                                                            <button
                                                                onClick={ () => vehicleLookup() }
                                                                disabled={
                                                                    stringHelpers.isNullOrEmpty(vrm) ||
                                                                    !stringHelpers.isValidVrm(vrm) ||
                                                                    (
                                                                        !stringHelpers.isNullOrEmpty(vrm) && !stringHelpers.isNullOrEmpty(successfulLookupVrm) && vrm === successfulLookupVrm
                                                                    ) ||
                                                                    loadingVehicleLookup
                                                                }
                                                                className='btn btn-falcon-default btn-sm ml-3 mt-2'
                                                            >
                                                                <div className='d-flex align-items-center'>
                                                                    {
                                                                        loadingVehicleLookup
                                                                            ? <span className="tiny-loader mr-2"><Loader /></span>
                                                                            : <i className='fas fa-search mr-1'></i>
                                                                    }
                                                                    Vehicle Lookup
                                                                </div>
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Reference</p>
                                                    </div>
                                                    <div className="col-md-8 col-12 ">
                                                        <div className="form-group mb-1">
                                                            <input className="form-control mb-0" type="text" value={ reference } onChange={ (e) => setReference(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Vehicle Make</p>
                                                    </div>
                                                    <div className="col-md-8 col-12 ">
                                                        <div className="form-group mb-1">
                                                            <input disabled={ loadingVehicleLookup } className="form-control mb-0" type="text" value={ vehicleMake } onChange={ (e) => setVehicleMake(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Vehicle Model</p>
                                                    </div>
                                                    <div className="col-md-8 col-12 ">
                                                        <div className="form-group mb-1">
                                                            <input disabled={ loadingVehicleLookup } className="form-control mb-0" type="text" value={ vehicleModel } onChange={ (e) => setVehicleModel(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Colour</p>
                                                    </div>
                                                    <div className="col-md-8 col-12 ">
                                                        <div className="form-group mb-1">
                                                            <input disabled={ loadingVehicleLookup } className="form-control mb-0" type="text" value={ colour } onChange={ (e) => setColour(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="border-dashed border-bottom-0"></hr>
                                                <h6 className="mb-3 fs-1">Driver Details</h6>
                                                <div className="row">
                                                    <div className="col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Name</p>
                                                    </div>
                                                    <div className="col-md-8 col-12">
                                                        <div className="form-group mb-0">
                                                            <input className="form-control mb-1" type="text" value={ driverName } onChange={ (e) => setDriverName(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Mobile Number</p>
                                                    </div>
                                                    <div className="col-md-8 col-12">
                                                        <div className="form-group mb-0">
                                                            <input className="form-control mb-1" type="text" value={ driverMobileNumber } onChange={ (e) => setDriverMobileNumber(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Email Address</p>
                                                    </div>
                                                    <div className="col-md-8 col-12">
                                                        <div className="form-group mb-1">
                                                            <input className="form-control mb-0" type="text" value={ driverEmailAddress } onChange={ (e) => setDriverEmailAddress(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Blue Badge Number</p>
                                                    </div>
                                                    <div className="col-md-8 col-12">
                                                        <div className="form-group mb-1">
                                                            <input className="form-control mb-0" type="text" value={ blueBadgeNumber } onChange={ (e) => setBlueBadgeNumber(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Blue Badge Expiry Date</p>
                                                    </div>
                                                    <div className="col-md-8 col-12">
                                                        <div className="form-group mb-1">
                                                            <input className="form-control mb-0" type="date" value={ toInputFieldDateString(blueBadgeExpiryDate) } onChange={ (e) => setBlueBadgeExpiryDate(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="border-dashed border-bottom-0"></hr>
                                                <ClientSiteTabbed
                                                    clients={ clients }
                                                    client={ clientId }
                                                    onTabChange={ e => {
                                                        setSiteGroup("");
                                                        setClientId("");
                                                        setTabActiveKey(e);
                                                        setRoi(null)
                                                    } }
                                                    anprCameraId={ null }
                                                    site={ site }
                                                    sites={ null }
                                                    activeKey={ tabActiveKey }
                                                    siteGroups={ siteGroups }
                                                    siteGroup={ siteGroup }
                                                    setSiteGroup={ setSiteGroup }
                                                    anprCameras={ null }
                                                    roi={ roi }
                                                    setRoi={ setRoi }
                                                    labelWidthClass='col-md-4 col-12'
                                                    fieldWidthClass='col-md-8 col-12'
                                                    setClient={ setClientId }
                                                />
                                                <hr className="border-dashed border-bottom-0"></hr>
                                                <div className="mandatory-date-time">
                                                <div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-4 col-12 ">
                                                            <h6 className="mb-3 fs-1">Date/Time Details</h6>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="d-flex align-items-center mb-1">
                                                                <input checked={ typeDateTime === "0" } id={ "0" } onChange={ () => {
                                                                    setTypeDateTime("0")
                                                                    setStartDate("")
                                                                    setEndDate("")
                                                                } } className='mr-2' name="type-date-time-selection-radio" key={ "0" } value={ "0" } type='radio' />
                                                                <label className='m-0' htmlFor={ "0" }>Indefinite (no start/end date)</label>
                                                            </div>

                                                            <div className="d-flex mb-1 align-items-start">
                                                                <input checked={ typeDateTime === "1" } id={ "1" } onChange={ () => {
                                                                    setTypeDateTime("1")
                                                                    setStartDate(toInputFieldDateTimeString(firstDate))
                                                                    setEndDate(toInputFieldDateTimeString(lastDate))
                                                                } } className='mr-2 mt-1' name="type-date-time-selection-radio" key={ "1" } value={ "1" } type='radio' />
                                                                <div className="">
                                                                    <label className='m-0 d-flex flex-column' htmlFor={ "1" }>
                                                                        Today
                                                                        <small>{ toDateString(firstDate) }, { toTimeString(firstDate) } - { toTimeString(lastDate) }</small>
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            <div className="d-flex align-items-center mb-1">
                                                                <input checked={ typeDateTime === "2" } id={ "2" } onChange={ () => {
                                                                    setTypeDateTime("2")
                                                                    setStartDate("")
                                                                    setEndDate("")
                                                                } } className='mr-2' name="type-date-time-selection-radio" key={ "2" } value={ "2" } type='radio' />
                                                                <label className='m-0' htmlFor={ "2" }>Specific date range</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    typeDateTime === "2"
                                                    &&
                                                    <>
                                                        
                                                            <div className="row mb-3">
                                                                <div className="col-md-4 col-12 ">
                                                                    <p className="text-left font-weight-semi-bold  mt-1 mb-1">Date Range</p>
                                                                </div>
                                                                <div className="col-md-8 col-12 d-flex align-items-center">
                                                                    <div className="form-group mb-0">
                                                                        <DateTimePickerWithCustomDisplay 
                                                                            customDisplayText="No start date"
                                                                            onChange={v => setStartDate(v)}
                                                                            value={toInputFieldDateTimeString(startDate)}
                                                                        />
                                                                    </div>
                                                                    <p className='m-0 mx-2'>To</p>
                                                                    <div className="form-group mb-0">
                                                                        <DateTimePickerWithCustomDisplay 
                                                                            customDisplayText="No end date"
                                                                            onChange={v => setEndDate(v)}
                                                                            value={toInputFieldDateTimeString(endDate)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        
                                                        <div className="row mt-3">
                                                            <div className="col-md-4 col-12 ">
                                                                <p className="text-left font-weight-semi-bold  mt-1 mb-1">Valid only on specific days</p>
                                                            </div>
                                                            <div className="col-md-8 col-12 custom-control custom-switch">
                                                                <input className="custom-control-input" type="checkbox" id="valid-specific-days-toggle" checked={ validOnlyOnSpecificDays } onChange={ e => {
                                                                    setValidOnlyOnSpecificDays(!validOnlyOnSpecificDays)
                                                                    if (!e.target.checked) {
                                                                        setValidOnlyOnSpecificDays(false)
                                                                        setIsValidMonday(false)
                                                                        setIsValidTuesday(false)
                                                                        setIsValidWednesday(false)
                                                                        setIsValidThursday(false)
                                                                        setIsValidFriday(false)
                                                                        setIsValidSaturday(false)
                                                                        setIsValidSunday(false)
                                                                    }
                                                                } } />
                                                                <label className="custom-control-label ml-3" htmlFor="valid-specific-days-toggle"></label>
                                                                <p className="text-left m-0 ml-3 mt-1">{ validOnlyOnSpecificDays ? <>Yes</> : <>No</> }</p>
                                                            </div>
                                                        </div>
                                                        <div className='mt-3'>
                                                            {
                                                                validOnlyOnSpecificDays &&
                                                                <>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Monday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-monday-switch" checked={ isValidMonday } onChange={ e => setIsValidMonday(prevState => !prevState) } />
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-monday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{ isValidMonday ? <>Yes</> : <>No</> }</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Tuesday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-tuesday-switch" checked={ isValidTuesday } onChange={ e => setIsValidTuesday(prevState => !prevState) } />
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-tuesday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{ isValidTuesday ? <>Yes</> : <>No</> }</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Wednesday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-wednesday-switch" checked={ isValidWednesday } onChange={ e => setIsValidWednesday(prevState => !prevState) } />
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-wednesday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{ isValidWednesday ? <>Yes</> : <>No</> }</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Thursday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-thursday-switch" checked={ isValidThursday } onChange={ e => setIsValidThursday(prevState => !prevState) } />
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-thursday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{ isValidThursday ? <>Yes</> : <>No</> }</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Friday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-friday-switch" checked={ isValidFriday } onChange={ e => setIsValidFriday(prevState => !prevState) } />
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-friday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{ isValidFriday ? <>Yes</> : <>No</> }</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Saturday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-saturday-switch" checked={ isValidSaturday } onChange={ e => setIsValidSaturday(prevState => !prevState) } />
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-saturday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{ isValidSaturday ? <>Yes</> : <>No</> }</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-4 col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-1">Sunday</p>
                                                                        </div>
                                                                        <div className="col-md-8 col-12 custom-control custom-switch">
                                                                            <input className="custom-control-input" type="checkbox" id="enable-sunday-switch" checked={ isValidSunday } onChange={ e => setIsValidSunday(prevState => !prevState) } />
                                                                            <label className="custom-control-label ml-3" htmlFor="enable-sunday-switch"></label>
                                                                            <p className="m-0 ml-3 mt-1">{ isValidSunday ? <>Yes</> : <>No</> }</p>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            }
                                                        </div>
                                                        <div className="row mt-3">
                                                            <div className="col-md-4 col-12 ">
                                                                <p className="text-left font-weight-semi-bold  mt-1 mb-1">Valid only at specific times of the day</p>
                                                            </div>
                                                            <div className="col-md-8 col-12 custom-control custom-switch">
                                                                <input className="custom-control-input" type="checkbox" id="valid-specific-times-toggle" checked={ validOnlyAtSpecificTimes } onChange={ e => {
                                                                    setValidOnlyAtSpecificTimes(!validOnlyAtSpecificTimes)
                                                                    if (!e.target.checked) {
                                                                        setValidOnlyAtSpecificTimes(false)
                                                                        setEnabledFromTime("00:00:00")
                                                                        setEnabledToTime("23:59:59")
                                                                    }
                                                                } } />
                                                                <label className="custom-control-label ml-3" htmlFor="valid-specific-times-toggle"></label>
                                                                <p className="text-left m-0 ml-3 mt-1">{ validOnlyAtSpecificTimes ? <>Yes</> : <>No</> }</p>
                                                            </div>
                                                        </div>
                                                        {
                                                            validOnlyAtSpecificTimes &&
                                                            <div className="row mb-3">
                                                                <div className="col-md-4 col-12 ">
                                                                    <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Time Range</p>
                                                                </div>
                                                                <div className="col-md-7 col-12">
                                                                    <TimeRangeSlider
                                                                        startTime={ enabledFromTime }
                                                                        endTime={ enabledToTime }
                                                                        onChange={ value => {
                                                                            setEnabledFromTime(value.startTime)
                                                                            setEnabledToTime(value.endTime)
                                                                        } }
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                }
                                                    
                                                        <div className="row mt-3 mb-1">
                                                            <div className="col-md-4 col-12 ">
                                                                <p className="font-weight-semi-bold mb-1">Maximum Stay</p>
                                                            </div>
                                                            <div className="col-md-8 col-12 d-flex align-items-center">
                                                                <MinutesInputWithUnit
                                                                    numberOfMinutes={ maxStayMinutes }
                                                                    handleChange={ setMaxStayMinutes }
                                                                />
                                                                <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setMaxStayMinutes(null) }>
                                                                    <i className="fas fa-undo mr-1"></i>
                                                                    Clear
                                                                </button>
                                                            </div>
                                                        </div>
                                                    
                                                
                                                    
                                                        <div className="row mb-3">
                                                            <div className="col-md-4 col-12 ">
                                                                <p className="font-weight-semi-bold mb-1">No return within</p>
                                                            </div>
                                                            <div className="col-md-8 col-12 d-flex align-items-center">
                                                                <MinutesInputWithUnit
                                                                        numberOfMinutes={ noReturnWithinMinutes }
                                                                        handleChange={ setNoReturnWithinMinutes }
                                                                    />
                                                                    <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setNoReturnWithinMinutes(null) }>
                                                                        <i className="fas fa-undo mr-1"></i>
                                                                        Clear
                                                                    </button>
                                                            </div>
                                                        </div>
                                                    
                                                </div>
                                                <hr className="border-dashed border-bottom-0"></hr>
                                                <div className="row">
                                                    <div className="col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold mt-1 mb-1 text-left">Notes</p>
                                                    </div>
                                                    <div className="col-md-8 col-12">
                                                        <div className="form-group mb-1">
                                                            <textarea className="form-control mb-0" rows={ 3 } value={ reason } onChange={ (e) => setReason(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal" onClick={ () => {
                                                    setClientId("");
                                                    setTabActiveKey("site");
                                                } }>
                                                    <i className="fas fa-times"></i> Cancel</button>
                                                <button type="button" className="btn btn-success btn-sm ml-2" disabled={ !canSave } data-dismiss="modal" onClick={ () => submit() }>
                                                    <i className="fas fa-check"></i> Confirm</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                showNewLayout
                                ? <>
                                    <div className='row my-3'>
                                        <div className="h-100 breach-details-pane w-100 bg-transparent">
                                            <div className="pt-2">
                                                <div className="mb-3">
                                                    <div style={ { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "1rem" } }>
                                                        <div className='card px-3 py-2'>
                                                            <div className="row">
                                                                <label class="col-sm-4 col-form-label col-form-label-xs">Breach Date</label>
                                                                <div className="col-sm-8">
                                                                    { 
                                                                        !stringHelpers.isNullOrEmpty(breach.timestamp) &&
                                                                        <p class="form-control-plaintext form-control-sm outline-none" >
                                                                            { toDateString(breach.timestamp) } ({timeAgo(breach.timestamp)})
                                                                        </p>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <label class="col-sm-4 col-form-label col-form-label-xs">Breach Status</label>
                                                                <div className="col-sm-8 mb-1">
                                                                    { (roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) || isThirdPartyUser || roleUtilities.isOrganisationProcessor(props.user, props.organisationId)) ?
                                                                        <SearchSelect
                                                                            options={ breachStatusOptionsByRole() }
                                                                            onSelect={ value => setStatus(Number(value)) }
                                                                            selected={ String(status) }
                                                                        />
                                                                        : <p class="form-control-plaintext form-control-sm outline-none" >{ Enums.BreachStatus[status] }</p>
                                                                    }
                                                                </div>
                                                            </div>
                                                            {
                                                                breach.isCurrentlyOnHold &&
                                                                <div className="row">
                                                                    <label class="col-sm-4 col-form-label col-form-label-xs">&nbsp;</label>
                                                                    <div className="col-sm-8 d-flex align-items-center">
                                                                        <p class="form-control-plaintext m-0">
                                                                            <i className='mr-1 fas fa-exclamation-triangle text-warning'></i>
                                                                            On hold
                                                                            { breach.isOnHoldExpiry && <> until { toDateString(breach.isOnHoldExpiry) }</> }
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            }
                                                            <div className="row">
                                                                <label class="col-sm-4 col-form-label col-form-label-xs">Assigned To</label>
                                                                <div className="col-sm-8">
                                                                    <p class="form-control-plaintext form-control-sm outline-none" >    { breach.assignedToUserName }{ breach.assignedToUserName === null && <>Unassigned</> }</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="card p-3">
                                                            <OutstandingBalancePane user={ props.user } organisationId={ props.organisationId } showNewLayout={ showNewLayout } breach={ breach } onSave={ onSaveReducedCharge } />
                                                        </div>
                                                    </div>
                                                    <div className='card px-3 py-3 mt-2'>
                                                        <h6 className='m-0 mr-2 mb-3'>Vehicle and Ticket Details</h6>
                                                        <div></div>
                                                        <div style={ { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "2rem" } }>
                                                            <div>
                                                                <div className="row mb-1">
                                                                    <label class="col-sm-4 col-form-label col-form-label-xs">Site{ticketDetailsInEdit && <span className="req"></span>}</label>
                                                                    <div className="col-sm-8">

                                                                        {
                                                                            allContraventions?.find(x => x.id === breach.contraventionId)?.contraventionType === 1 && ticketDetailsInEdit
                                                                                ? <div>
                                                                                    <SearchSelect
                                                                                    options={ props.sites.map(item => ({ value: item.id, label: item.name })) }
                                                                                    onSelect={ value => {
                                                                                        setSelectedSiteByClient(value)
                                                                                        getSiteContraventions(value)
                                                                                    } }
                                                                                    selected={ selectedSiteByClient }
                                                                                    defaultLabel="All"
                                                                                />
                                                                                {stringHelpers.isNullOrEmpty(selectedSiteByClient) && <small className='text-danger'>Please select a site</small>}
                                                                                </div>
                                                                                : <p class="form-control-plaintext form-control-sm outline-none" >{ breach.siteName }</p>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                
                                                                { !ticketDetailsInEdit && <>

                                                                    <div className="row align-items-center">
                                                                        <label class="col-sm-4 col-form-label col-form-label-xs">VRM</label>
                                                                        <div className="col-sm-8">
                                                                            <p className="small-number-plate mb-2">{ breach.vrm }</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <label class="col-sm-4 col-form-label col-form-label-xs">Vehicle Make</label>
                                                                        <div className="col-sm-8">
                                                                            <p class="form-control-plaintext form-control-sm outline-none" >{ lookupMake }</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <label class="col-sm-4 col-form-label col-form-label-xs">Vehicle Model</label>
                                                                        <div className="col-sm-8">
                                                                            <p class="form-control-plaintext form-control-sm outline-none" >{ lookupModel }</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <label class="col-sm-4 col-form-label col-form-label-xs">Vehicle Colour</label>
                                                                        <div className="col-sm-8">
                                                                            <p class="form-control-plaintext form-control-sm outline-none" >{ lookupColour }</p>
                                                                        </div>
                                                                    </div>
                                                                </> }
                                                                { ticketDetailsInEdit && <>
                                                                    <div className="row align-items-center">
                                                                        <label class="col-sm-4 col-form-label col-form-label-xs">VRM<span className="req"></span></label>
                                                                        <div className="col-sm-8">
                                                                            <div className='d-flex align-items-center'>
                                                                                <input required className="form-control form-control-sm mb-1 mr-2" type="text" value={ vrm } onChange={ (e) => {
                                                                                    setVrm(e.target.value)
                                                                                    formUtilities.requiredField(e.target.parentNode, e.target.value)
                                                                                } } />
                                                                                <button
                                                                                    onClick={ () => {
                                                                                        setLoadingVehicleLookup(true)
                                                                                        Api.vehicleLookup(
                                                                                            data => {
                                                                                                if (data.isError) {
                                                                                                    setTicketDetailsLookupError(data.errorMessage)
                                                                                                } else {
                                                                                                    setLookupMake(data.vehicleMake)
                                                                                                    setLookupModel(data.vehicleModel)
                                                                                                    setLookupColour(data.vehicleColour)
                                                                                                    setSuccessfulLookupVrm(vrm)
                                                                                                    setTicketDetailsLookupError(null)
                                                                                                }
                                                                                                setLoadingVehicleLookup(false)
                                                                                            },
                                                                                            () => {
                                                                                                setTicketDetailsLookupError("Unable to find vehicle details")
                                                                                                setLoadingVehicleLookup(false)
                                                                                            },
                                                                                            vrm.toLowerCase(),
                                                                                            props.organisationId, props.token
                                                                                        )
                                                                                    } }
                                                                                    disabled={
                                                                                        stringHelpers.isNullOrEmpty(vrm) ||
                                                                                        !stringHelpers.isValidVrm(vrm) ||
                                                                                        (
                                                                                            !stringHelpers.isNullOrEmpty(vrm) && !stringHelpers.isNullOrEmpty(successfulLookupVrm) && vrm === successfulLookupVrm
                                                                                        ) ||
                                                                                        loadingVehicleLookup
                                                                                    }
                                                                                    className='btn btn-falcon-default btn-sm mb-1 text-nowrap'
                                                                                >
                                                                                    <div className='d-flex align-items-center'>
                                                                                        {
                                                                                            loadingVehicleLookup
                                                                                                ? <span className="tiny-loader mr-2"><Loader /></span>
                                                                                                : <i className='fas fa-search mr-1'></i>
                                                                                        }
                                                                                        Vehicle Lookup
                                                                                    </div>
                                                                                </button>
                                                                            </div>
                                                                            {
                                                                                !stringHelpers.isNullOrEmpty(ticketDetailsLookupError) && <small className='text-danger'>{ticketDetailsLookupError}</small>
                                                                            }
                                                                            <small className='invalid-feedback text-danger'>Please enter a VRM</small>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row align-items-center">
                                                                        <label class="col-sm-4 col-form-label col-form-label-xs">Vehicle Make</label>
                                                                        <div className="col-sm-8">
                                                                            <input className="form-control form-control-sm mb-1" type="text" value={ lookupMake } onChange={ (e) => setLookupMake(e.target.value) } />
                                                                        </div>
                                                                    </div>
                                                                    <div className="row align-items-center">
                                                                        <label class="col-sm-4 col-form-label col-form-label-xs">Vehicle Model</label>

                                                                        <div className="col-sm-8">
                                                                            <input className="form-control form-control-sm mb-1" type="text" value={ lookupModel } onChange={ (e) => setLookupModel(e.target.value) } />
                                                                        </div>
                                                                    </div>
                                                                    <div className="row align-items-center">
                                                                        <label class="col-sm-4 col-form-label col-form-label-xs">Vehicle Colour</label>
                                                                        <div className="col-sm-8">
                                                                            <input className="form-control form-control-sm mb-1" type="text" value={ lookupColour } onChange={ (e) => setLookupColour(e.target.value) } />
                                                                        </div>
                                                                    </div>
                                                                </> }
                                                            </div>
                                                            <div>
                                                                <div className="row">
                                                                    <label class="col-sm-4 col-form-label col-form-label-xs">Number of Breaches</label>
                                                                    <div className="col-sm-8">
                                                                        <p class="form-control-plaintext form-control-sm outline-none" >{ numberOfBreaches }</p>
                                                                    </div>
                                                                </div>
                                                                { !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <div className="row">
                                                                    <label class="col-sm-4 col-form-label col-form-label-xs">Contravention{ticketDetailsInEdit && <span className="req"></span>}</label>
                                                                    <div className=" col-sm-8">
                                                                        {
                                                                            !ticketDetailsInEdit
                                                                                ? <p class="form-control-plaintext form-control-sm outline-none">
                                                                                    { breach?.contraventionName } ({Enums.ContraventionTypes[allContraventions?.find(item => item.id === contraventionId)?.contraventionType]})
                                                                                </p>
                                                                                : <div>
                                                                                    <select disabled={ status !== 0 } class="custom-select custom-select-sm" onChange={ (e) => {
                                                                                        if (stringHelpers.isNullOrEmpty(e.target.value)) {
                                                                                            setContraventionValidation("Please select a contravention")
                                                                                        } else {
                                                                                            setContraventionValidation(null)
                                                                                        }
                                                                                        setContraventionId(e.target.value)
                                                                                    } }>
                                                                                        <option value="">Select a contravention</option>
                                                                                    { !arrayUtilities.isNullOrEmpty(siteContraventions) &&
                                                                                        <>
                                                                                            { siteContraventions.map((siteContravention) => {
                                                                                                let contravention = null;
                                                                                                if (allContraventions && allContraventions !== null && allContraventions.length > 0) {
                                                                                                    allContraventions.forEach(x => {
                                                                                                        if (siteContravention.contraventionId === x.id) {
                                                                                                            contravention = x;
                                                                                                        }
                                                                                                    });
                                                                                                }
                                                                                                return <option value={ contravention.id } selected={ contravention.id === contraventionId }>{ contravention.name } ({Enums.ContraventionTypes[contravention.contraventionType]})</option>
                                                                                            }) }
                                                                                        </>
                                                                                    }
                                                                                </select>
                                                                                {!stringHelpers.isNullOrEmpty(contraventionValidation) && <small className='text-danger'>{contraventionValidation}</small>}
                                                                                </div>
                                                                        }
                                                                    </div>
                                                                </div> }

                                                                <div className="row">
                                                                    <label class="col-sm-4 col-form-label col-form-label-xs">Duplicate Ticket Check</label>
                                                                    <div className="col-sm-8">
                                                                        <p class="form-control-plaintext form-control-sm outline-none" >
                                                                            { dupeTicket === null &&
                                                                                <>No Duplicates Found</>
                                                                            }
                                                                            { dupeTicket !== null &&
                                                                                <Link>{ dupeTicket.referenceNumber }</Link>
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                {
                                                                    breach.parkingSession !== null &&
                                                                    <>
                                                                        {
                                                                            !arrayUtilities.isNullOrEmpty(allContraventions) && allContraventions.find(x => x.id === contraventionId)?.contraventionType === 1 &&
                                                                            <>
                                                                                <div className="row">
                                                                                    <label className="col-sm-4 col-form-label col-form-label-xs">Observed from{ticketDetailsInEdit && <span className="req"></span>}</label>
                                                                                    <div className="col-sm-8">
                                                                                        {
                                                                                            !ticketDetailsInEdit
                                                                                                ? <p className="form-control-plaintext form-control-sm outline-none">
                                                                                                    { toDateTimeString(breach.parkingSession?.entry?.timestamp, true) }
                                                                                                </p>
                                                                                                : <div>
                                                                                                    <input required className="form-control form-control-sm" type="datetime-local" value={ toInputFieldDateTimeString(observedFrom) } onChange={ (e) => {
                                                                                                    setObservedFrom(e.target.value)
                                                                                                    setDuration(durationBetweenString(e.target.value, observedTo))
                                                                                                } } />
                                                                                                {stringHelpers.isNullOrEmpty(observedFrom) && <small className='text-danger'>Please enter a date</small>}
                                                                                                </div>
                                                                                        }
                                                                                    </div>
                                                                                </div>

                                                                                <div className="row">
                                                                                    <label class="col-sm-4 col-form-label col-form-label-xs">Observed to{ticketDetailsInEdit && <span className="req"></span>}</label>
                                                                                    <div className="col-sm-8">
                                                                                        {
                                                                                            !ticketDetailsInEdit
                                                                                                ? <p class="form-control-plaintext form-control-sm outline-none m-0">
                                                                                                    { toDateTimeString(breach.parkingSession?.exit?.timestamp, true) }
                                                                                                </p>
                                                                                                : <div>
                                                                                                    <input required className="form-control form-control-sm" type="datetime-local" value={ toInputFieldDateTimeString(observedTo) } onChange={ (e) => {
                                                                                                    setObservedTo(e.target.value)
                                                                                                    setDuration(durationBetweenString(observedFrom, e.target.value))
                                                                                                } } />
                                                                                                {stringHelpers.isNullOrEmpty(observedTo) && <small className='text-danger'>Please enter a date</small>}
                                                                                                </div>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        }

                                                                        <div className="row">
                                                                            <label class="col-sm-4 col-form-label col-form-label-xs">Duration</label>
                                                                            <div className="col-sm-8">
                                                                                <p class="form-control-plaintext form-control-sm outline-none pt-1">
                                                                                    { duration }
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                }

                                                            </div>
                                                        </div>
                                                        <div className='d-flex justify-content-end'>
                                                            {
                                                                !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) &&

                                                                <>
                                                                    {
                                                                        !ticketDetailsInEdit
                                                                            ? <button className="btn-sm btn btn-falcon-default" onClick={ () => setTicketDetailsInEdit(true) }><i className="fas fa-edit mr-1"></i>Edit Ticket Details</button>
                                                                            : <>
                                                                                <button className="btn-sm btn btn-danger mr-1" onClick={ () => {
                                                                                    setObservedFrom(breach?.parkingSession?.entry?.timestamp)
                                                                                    setObservedTo(breach?.parkingSession?.exit?.timestamp)
                                                                                    setDuration(durationBetweenString(breach?.parkingSession?.entry?.timestamp, breach?.parkingSession?.exit?.timestamp))
                                                                                    setContraventionId(breach.contraventionId)
                                                                                    setVrm(breach.vrm)
                                                                                    setLookupMake(breach.vehicleMake);
                                                                                    setLookupColour(breach.vehicleColour);
                                                                                    setLookupModel(breach.vehicleModel);
                                                                                    setSelectedSiteByClient(breach.siteId)
                                                                                    setTicketDetailsInEdit(false)
                                                                                } }><i className="fas fa-times mr-1"></i>Cancel</button>
                                                                                <button disabled={ stringHelpers.isNullOrEmpty(vrm) || stringHelpers.isNullOrEmpty(contraventionId) || stringHelpers.isNullOrEmpty(selectedSiteByClient) || stringHelpers.isNullOrEmpty(observedFrom) || stringHelpers.isNullOrEmpty(observedTo) } className="btn-sm btn btn-success mx-1" onClick={ () => editBreach(selectedSiteByClient) }><i className="fas fa-check mr-1"></i>Confirm</button>
                                                                            </>
                                                                    }
                                                                </>

                                                            }
                                                        </div>
                                                    </div>

                                                </div>

                                                {
                                                    !arrayUtilities.isNullOrEmpty(allContraventions) && allContraventions.find(x => x.id === breach.contraventionId)?.contraventionType === 0 &&
                                                    <div className="breach-general-details">
                                                        <div className="card px-3 pt-3 pb-4">
                                                            <div className="row">
                                                                <div className="col-4 d-flex flex-column mr-1">
                                                                    <h6 className="text-nowrap">Camera In</h6>
                                                                    <div className="d-flex flex-column">
                                                                        <div className="d-flex align-items-center mb-2">
                                                                            <i className="far fa-calendar-alt mr-1"></i>
                                                                            <p className="form-control-plaintext form-control-sm outline-none">{ toDateString(breach.parkingSession?.entry?.timestamp) }</p>
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <i className="far fa-clock mr-1"></i>
                                                                            <p className="form-control-plaintext form-control-sm outline-none">{ toTimeString(breach.parkingSession?.entry?.timestamp, true) }</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="breach-camera-image">
                                                                    { breach.parkingSession?.entry?.imageUrls.map((item) => {
                                                                        if (item.toString().search("overview") !== -1) {
                                                                            var url = item + '?ts=' + timestamp;
                                                                            return <RedactionPane token={ props.token } organisationId={ props.organisationId } onChange={ reloadImages } id={ breach.parkingSession?.entry?.id } url={ url } />
                                                                        } else {
                                                                            return (
                                                                                <div className="breach-image breach-number-plate">
                                                                                    <img src={ item } className="py-1" />
                                                                                </div>
                                                                            )
                                                                        }
                                                                    }) }
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="card px-3 pt-3 pb-4">
                                                            <div className="row">
                                                                <div className="col-4 d-flex flex-column mr-1">
                                                                    <h6 className="text-nowrap">Camera Out</h6>
                                                                    <div className="d-flex flex-column">
                                                                        <div className="d-flex align-items-center mb-2">
                                                                            <i className="far fa-calendar-alt mr-1"></i>
                                                                            <p className="form-control-plaintext form-control-sm outline-none">{ toDateString(breach.parkingSession?.exit?.timestamp) }</p>
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <i className="far fa-clock mr-1"></i>
                                                                            <p className="form-control-plaintext form-control-sm outline-none">{ toTimeString(breach.parkingSession?.exit?.timestamp, true) }</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="breach-camera-image">
                                                                    { breach.parkingSession?.exit?.imageUrls.map((item) => {
                                                                        if (item.toString().search("overview") !== -1) {
                                                                            var url = item + '?ts=' + timestamp;
                                                                            return <RedactionPane token={ props.token } organisationId={ props.organisationId } onChange={ reloadImages } id={ breach.parkingSession?.exit?.id } url={ url } />
                                                                        } else {
                                                                            return (
                                                                                <div className="breach-image breach-number-plate">
                                                                                    <img src={ item } className="py-1" />
                                                                                </div>
                                                                            )
                                                                        }
                                                                    }) }
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                <div className="card row mt-2">
                                    <Tab.Container defaultActiveKey={ activeNavIndex } transition={ Fade } onSelect={ e => setActiveNavIndex(e) }>
                                        <div className='row align-items-center w-100 px-3'>
                                            <Nav className="breach-details-tab-nav d-flex w-100 justify-content-between px-3">
                                            {
                                                !arrayUtilities.isNullOrEmpty(navItems) && navItems.map((navItem, index) =>
                                                    <Nav.Item key={ index } className={ `py-1 cursor-pointer fs--1` }>
                                                        <Nav.Link className={ `d-flex align-items-center bg-transparent px-0 text-nowrap` } eventKey={ index }>
                                                            <div className={ `d-flex align-items-center mr-0 ${ String(index) === activeNavIndex ? "text-primary" : "text-secondary" }` }>
                                                                <i className={ `mr-2 ${ navItems[index].iconClass }` }></i>
                                                                <p className='m-0'>{ navItems[index].label }</p>
                                                            </div>
                                                            <div className='nav-badge'>
                                                                {
                                                                    navItem.isLoading
                                                                        ? <span className='tiny-loader mb-0'><Loader /></span>
                                                                        : navItem.badgeValue !== null &&
                                                                        <span className={ `ml-1 badge badge-${ navItem.badgeValue === 0 ? "secondary" : "success" }` }>{ navItem.badgeValue }</span>
                                                                }
                                                            </div>
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                )
                                            }
                                        </Nav>
                                        </div>
                                        <Tab.Content className='w-100' id="breach-details-tab-content">
                                            <Tab.Pane eventKey="0" className='px-0'>
                                                {
                                                    !stringHelpers.isNullOrEmpty(vrm) && site && allowedVrms &&
                                                    <div className="h-100 w-100">
                                                        <div className="card-header my-1">
                                                            <div className='d-flex align-items-center'>
                                                                <label className='m-0 mr-3'>Similarity: { allowedVrmsSimilarityThreshold }%</label>
                                                                <input class="form-range" type="range" min="0" max="100" value={ allowedVrmsSimilarityThreshold } onTouchEnd={ onAllowedVrmSimilarityThresholdChanged } onMouseUp={ onAllowedVrmSimilarityThresholdChanged } onChange={ (e) => setAllowedVrmsSimilarityThreshold(Number(e.target.value)) } />
                                                            </div>
                                                        </div>
                                                        <div className="p-0" aria-labelledby="Allow List">
                                                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer">
                                                                <thead className="bg-200 text-900">
                                                                    <tr>
                                                                        <th>VRM</th>
                                                                        <th>Similarity</th>
                                                                        <th>&nbsp;</th>
                                                                        <th>Driver Name</th>
                                                                        <th>Vehicle Make</th>
                                                                        <th>Vehicle Model</th>
                                                                        <th>Site</th>
                                                                        <th>Start Date</th>
                                                                        <th>End Date</th>
                                                                        <th>Duration</th>
                                                                        <th>Created Date</th>
                                                                        <th>Created By</th>
                                                                        <th>Validity</th>
                                                                        <th className='text-center'>Enabled</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        navItems[0].isLoading
                                                                            ? <tr>
                                                                                <td colSpan={ 12 }>
                                                                                    <Loader />
                                                                                </td>
                                                                            </tr>
                                                                            : !arrayUtilities.isNullOrEmpty(allowedVrms.items) && allowedVrms.items.map((item) => {
                                                                                var url = "/organisation/" + props.organisationId + "/allowed-vrm/" + item.id;
                                                                                let similarityPercent = (item.similarity * 100).toFixed(0);
                                                                                let similarityClass = item.similarity > 0.99 ? "bg-success" : (item.similarity > 0.6 ? "bg-warning" : "bg-danger");

                                                                                return (
                                                                                    <tr>
                                                                                        <td><Link to={ url } className="number-plate-link"><h6 className="mb-0 small-number-plate" >{ item.vrm }</h6></Link></td>
                                                                                        <td>
                                                                                            <div class="progress" style={ { minWidth: "100px" } }>
                                                                                                <div class={ `progress-bar text-left pl-1 ${ similarityClass }` } role="progressbar" style={ { width: `${ similarityPercent }%` } } aria-valuenow={ similarityPercent } aria-valuemin="0" aria-valuemax="100">{ similarityPercent }%</div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className="text-center">{
                                                                                            !stringHelpers.isNullOrEmpty(item.blueBadgeNumber) && <img width="20px" src='/assets/img/illustrations/wheelchair-symbol.svg' />
                                                                                        }</td>
                                                                                        <td>{ item.driverName }</td>
                                                                                        <td>{ item.vehicleMake }</td>
                                                                                        <td>{ item.vehicleModel }</td>
                                                                                        <td>{ !stringHelpers.isNullOrEmpty(item.siteId) ? item.siteName : !stringHelpers.isNullOrEmpty(item.clientId) ? item.clientName : <>All</> }</td>
                                                                                        <td>
                                                                                            {
                                                                                                !stringHelpers.isNullOrEmpty(item.startDate)
                                                                                                    ? <>{ toDateTimeString(item.startDate) } </>
                                                                                                    : <span>&mdash; </span>
                                                                                            }
                                                                                        </td>
                                                                                        <td>
                                                                                            {
                                                                                                !stringHelpers.isNullOrEmpty(item.endDate)
                                                                                                    ? <>{ toDateTimeString(item.endDate) } <span className='text-end'>{ isDateTimeElapsed(item.endDate) && <i class="fas fa-exclamation-triangle text-warning ml-2 fs-1"></i> }</span></>
                                                                                                    : <span>&mdash; </span>
                                                                                            }
                                                                                        </td>
                                                                                        <td>{durationBetweenString(item.startDate, item.endDate)}</td>
                                                                                        <td>{ !stringHelpers.isNullOrEmpty(item.createdTimestamp) && toDateTimeString(item.createdTimestamp) }</td>
                                                                                        <td>{ item.createdByUserName }</td>
                                                                                        <td>{ renderValidity(item)}</td>
                                                                                        <td className='text-center'>{ item.isEnabled ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i> }</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <div className="card-footer border-top ">
                                                                <div className="d-flex justify-content-center row align-items-center">
                                                                    <div className="col-auto align-items-center">
                                                                        <Pagination totalResults={ allowedVrms?.totalCount } currentPage={ allowedVrmsPageNumber } changePageNumber={ changePageNumberAllowedVrms } />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="1">
                                                <div className="h-100">
                                                    <div className="card-header">
                                                        {!roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <Link className="btn btn-success btn-sm" to={ newContactUrl }><i className="fas fa-plus"></i> Add</Link>}
                                                    </div>

                                                    <div className="p-0">
                                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                                            <thead className="bg-200 text-900">
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Contact Type</th>
                                                                    <th>Contact Source</th>
                                                                    <th className="text-center">Status</th>
                                                                    <th>&nbsp;</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                { 
                                                                navItems[1].isLoading ? <tr><td colSpan={5}><Loader /></td></tr>
                                                                : !arrayUtilities.isNullOrEmpty(contactDetailsList) && contactDetailsList.map((item) => {
                                                                    var url = '/organisation/' + props.organisationId + '/breach/' + breachId + '/contact-details/' + item.id;
                                                                    return (
                                                                        <>
                                                                            <tr>
                                                                                <td><Link className="button-no-style" to={ url }><h6 className="mb-0">{ stringHelpers.contactDetailsName(item) }</h6></Link></td>
                                                                                <td>{ Enums.ContactTypes[item.contactType] }</td>
                                                                                <td>{ Enums.ContactSource[item.contactSource] }</td>
                                                                                <td className="text-center">{ item.isActive && <><i className="fas fa-check text-success"></i></> }{ !item.isActive && <><i className="fas fa-times text-danger"></i></> }</td>
                                                                                {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <td className="text-right">
                                                                                    <Link to={ {
                                                                                        pathname: url,
                                                                                        state: {
                                                                                            editMode: true
                                                                                        }
                                                                                    } } className='btn btn-link'><i className="fas fa-edit text-secondary"></i></Link>
                                                                                </td>}
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                }) }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="2">
                                                {
                                                    !stringHelpers.isNullOrEmpty(vrm) && site && paymentsData &&
                                                    <div className="h-100">
                                                        <div className="card-header">
                                                            <div className='d-flex justify-content-start'>
                                                                <button
                                                                    className="btn btn-primary btn-sm mr-2 nowrap"
                                                                    onClick={ () => fetchPaymentsData(paymentsPageNumber, paymentsSimilarityThreshold) }>
                                                                    <i className="fas fa-redo"></i> Refresh
                                                                </button>
                                                                <div className='d-flex align-items-center mr-4'>
                                                                    <label className='m-0 mr-2'>Similarity: { paymentsSimilarityThreshold }%</label>
                                                                    <input class="form-range" type="range" min="0" max="100" value={ paymentsSimilarityThreshold } onChange={ (e) => changePaymentsSimilarityThreshold(e.target.value) } />
                                                                </div>

                                                                <div className='d-flex align-items-center'>
                                                                    <DateRangePicker 
                                                                        fromDate={paymentsFromDate}
                                                                        toDate={paymentsToDate}
                                                                        setDateRange={(firstDate, lastDate) => {
                                                                            setPaymentsFromDate(firstDate);
                                                                            setPaymentsToDate(lastDate);
                                                                        }}
                                                                        showClearOption
                                                                        dropdownPositionRight
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="p-0">
                                                            { navItems[2].isLoading
                                                            ? <Loader />
                                                            : <>
                                                                {
                                                                    paymentsData.items &&
                                                                    <div className="card-body bg-white border-top details-container p-0 overflow-auto">
                                                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer">
                                                                            <thead className="bg-200 text-900">
                                                                                <tr>
                                                                                    <th>&nbsp;</th>
                                                                                    <th>VRM</th>
                                                                                    <th>Similarity</th>
                                                                                    <th>Site</th>
                                                                                    <th>Start Date</th>
                                                                                    <th>End Date</th>
                                                                                    <th>Duration</th>
                                                                                    <th className='text-right pr-4'>Amount</th>
                                                                                </tr>
                                                                            </thead>
                                                            
                                                                            <tbody>
                                                                                {
                                                                                    !arrayUtilities.isNullOrEmpty(paymentsData.items) && paymentsData.items
                                                                                    .map(
                                                                                        item => <tr key={item.id}>
                                                                                            <td>
                                                                                                <span className="logo-container">{imageUtilities.fetchPaymentProviderLogo(item.provider)}</span>
                                                                                            </td>
                                                                                            <td><h6 className="mb-0 small-number-plate">{item.vrm}</h6></td>
                                                                                            <td>
                                                                                                <div class="progress" style={{minWidth: "100px"}}>
                                                                                                    <div 
                                                                                                        class={`progress-bar text-left pl-1 ${item.similarity > 0.99 ? "bg-success" : (item.similarity > 0.6 ? "bg-warning" : "bg-danger")}`} 
                                                                                                        role="progressbar" 
                                                                                                        style={{width: `${item.similarity * 100}%`}} 
                                                                                                        aria-valuenow={item.similarity} 
                                                                                                        aria-valuemin="0" 
                                                                                                        aria-valuemax="100"
                                                                                                    >{ stringHelpers.formatDecimal((item.similarity * 100), 0) }%
                                                                                                    </div>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>{item.siteName}</td>
                                                                                            <td>{toDateTimeString(item.start)}</td>
                                                                                            <td>{toDateTimeString(item.end)}</td>
                                                                                            <td>{durationBetweenString(item.start, item.end)}</td>
                                                                                            <td className='text-right pr-4'>{stringHelpers.formatDecimal(item.amount, 2, "£")}</td>
                                                                                        </tr>
                                                                                    )
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                }
                                                            </>
                                                        }
                                                        <div className="d-flex justify-content-center row align-items-center pt-2">
                                                            <div className="col-auto align-items-center">
                                                                <Pagination totalResults={ paymentsData?.totalCount } currentPage={ paymentsPageNumber } changePageNumber={ changePaymentsPageNumber } />
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                }
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="3">
                                                <div className='h-100'>
                                                    <div className='p-0'>
                                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer p-0">
                                                            <thead className="bg-200 text-900">
                                                                <tr>
                                                                    <th>PCN</th>
                                                                    <th className="text-center">VRM</th>
                                                                    <th className="text-center">Contravention Date</th>
                                                                    <th className="text-center">Last Image/Read</th>
                                                                    <th>Contravention</th>
                                                                    <th>Site</th>
                                                                    <th>Status</th>
                                                                    <th>Outstanding Charges</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    navItems[3].isLoading
                                                                        ? <tr><td colSpan={ 7 }><Loader /></td></tr>
                                                                        : !arrayUtilities.isNullOrEmpty(previousContraventions) && previousContraventions.map(item => {
                                                                            var url = "/organisation/" + props.organisationId + "/breach/" + item.id;
                                                                            var balance = '£' + (Math.round(item.outstandingBalance * 100) / 100).toFixed(2);
                                                                            return (
                                                                                <tr>
                                                                                    <td><Link to={ url }><h6 className="mb-0">{ item.referenceNumber }{ item.referenceNumber === null && <>Unknown</> }</h6></Link></td>
                                                                                    <td className="text-center"><h6 className="m-auto mb-0 small-number-plate">{ item.vrm }</h6></td>
                                                                                    <td className="text-center">{ item.timestamp !== null && <>{ toDateString(item.timestamp) }</> }</td>
                                                                                    <td className="text-center">
                                                                                        { item.parkingSession !== null && item.parkingSession.exit !== null && <>{ toDateTimeString(item.parkingSession.exit.timestamp) }</> }
                                                                                    </td>
                                                                                    <td>{ item.contraventionName }</td>
                                                                                    <td>{ item.siteName }</td>
                                                                                    <td>{ Enums.BreachStatus[item.breachStatus] }</td>
                                                                                    <td className="text-right">{ balance }</td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="4">
                                                <div className='h-100'>
                                                    <div className="modal fade save-dialog success-dialog" id="add-new-evidence" tabIndex="-1" role="dialog">
                                                        <UploadFile onSuccess={ (file) => attachFile(file) } type="Attachments" organisationId={ props.organisationId } />
                                                    </div>
                                                    <div className="card-header">
                                                        <button className="btn btn-success btn-sm" data-toggle="modal" data-target="#add-new-evidence" ><i className="fas fa-plus"></i> Add</button>
                                                        <Link to={
                                                            {
                                                                pathname: `/organisation/${ props.organisationId }/breach/${ breachId }/new-letter`,
                                                                state: { siteId: site?.id }
                                                            }
                                                         } className="btn btn-primary btn-sm ml-1"><i className="fas fa-envelope mr-2"></i>New Letter</Link>
                                                    </div>
                                                    <div className="card-body bg-light border-top details-container p-2">
                                                        { attachments && <BreachAttachmentsDisplay
                                                            attachments={ attachments }
                                                            imageAttachments={ imageAttachments }
                                                            onChange={ reloadImages }
                                                            showIsLetterImage={ !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) }
                                                            onIsLetterImageChange={ attachmentIsLetterImage }
                                                            organisationId={ props.organisationId }
                                                            token={ props.token }
                                                            userId={ props.user.id }
                                                            onDeleteClick={attachmentId => setDeleteAttachmentId(attachmentId)}
                                                        /> }
                                                    </div>
                                                </div>
                                                {
                                                    !stringHelpers.isNullOrEmpty(deleteAttachmentId) && 
                                                    <Modal key="delete-attachment-modal" show size="md">
                                                    <Modal.Header>
                                                        <Modal.Title className='text-danger'>
                                                            Delete Attachment
                                                        </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>Are you sure you want to delete this attachment?</Modal.Body>
                                                    <Modal.Footer>
                                                        <button className="btn btn-falcon-default btn-sm mt-1" onClick={ () => setDeleteAttachmentId(null) }>Cancel</button>
                                                        <button type="button" className="btn btn-danger btn-sm ml-2"
                                                            onClick={ () => {
                                                                console.log("delete in progress...")
                                                                Api.deleteBreachAttachment(
                                                                    data => {
                                                                        if (data.isError) {
                                                                            setErrorMessage(data.errorMessage)
                                                                        } else {
                                                                            setDeleteAttachmentId(null);
                                                                        }
                                                                        getBreach()
                                                                        setDeleteAttachmentId(null)
                                                                    },
                                                                    error => {
                                                                        console.log(error)
                                                                        setDeleteAttachmentId(null)
                                                                        setErrorMessage(error.errorMessage)
                                                                    }, breachId, deleteAttachmentId,
                                                                    props.organisationId, props.token,
                                                                    
                                                                )
                                                            } }
                                                        >
                                                            Delete
                                                        </button>
                                                    </Modal.Footer>
                                                </Modal>}
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="5">
                                                <div className='h-100'>
                                                    <div className="modal fade" id="note-modal" tabIndex="-1" role="dialog" aria-labelledby="On Hold Modal" aria-hidden="true">
                                                        <div className="modal-dialog" role="document">
                                                            <div className="modal-content">
                                                                <div className="modal-header">
                                                                    <h5 className="modal-title" id="deleteModalLabel">Add a note.</h5>
                                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                        <span aria-hidden="true">&times;</span>
                                                                    </button>
                                                                </div>
                                                                <div className="modal-body">
                                                                    <div className="row">
                                                                        <div className="col-12 ">
                                                                            <p className="font-weight-semi-bold  mt-1 mb-2">Note:</p>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <div className="form-group mb-0">
                                                                                <textarea className="form-control mb-0" rows={ 4 } value={ note } onChange={ (e) => setNote(e.target.value) } />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="modal-footer">
                                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                                    <button disabled={ stringHelpers.isNullOrEmpty(note) } type="button" className="btn btn-success btn-sm ml-2" data-dismiss="modal" onClick={ () => submitNote() }>
                                                                        Confirm</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <div className="card-header">
                                                        <button className="btn btn-success btn-sm" data-toggle="modal" data-target="#note-modal" ><i className="fas fa-plus"></i> Add</button>
                                                    </div>}
                                                    <div className="p-0">
                                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer">
                                                            <thead className="bg-200 text-900">
                                                                <tr>
                                                                    <th>User</th>
                                                                    <th>Note</th>
                                                                    <th className="text-center">Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                { !arrayUtilities.isNullOrEmpty(breach.breachLogs) && breach.breachLogs.map((item) => {
                                                                    var statusChange = false;
                                                                    if (item.oldBreachStatus !== item.newBreachStatus) {
                                                                        statusChange = true;
                                                                    }
                                                                    var onHoldChange = false;
                                                                    if (item.wasOnHold !== item.isOnHold) {
                                                                        onHoldChange = true;
                                                                    }
                                                                    return (
                                                                        <>
                                                                            <tr className="align-items-center">
                                                                                <td><button className="button-no-style pt-1 mt-1"><h6 className="pt-1">{ item.userName !== null && <>{ item.userName }</> }{ item.userName === null && <>Unknown</> }</h6></button></td>
                                                                                <td>

                                                                                    { statusChange &&
                                                                                        <div>
                                                                                            { Enums.BreachStatus[item.oldBreachStatus] } <i className="fas fa-arrow-right"></i> { Enums.BreachStatus[item.newBreachStatus] }
                                                                                        </div>
                                                                                    }
                                                                                    { !stringHelpers.isNullOrEmpty(item.note) &&
                                                                                        <div>
                                                                                            { item.note }
                                                                                        </div>
                                                                                    }
                                                                                    { onHoldChange && <>

                                                                                        { item.isOnHold &&
                                                                                            <div>
                                                                                                Placed on hold
                                                                                            </div>
                                                                                        }
                                                                                        { !item.isOnHold &&
                                                                                            <div>
                                                                                                Taken off hold
                                                                                            </div>
                                                                                        }
                                                                                    </> }
                                                                                </td>
                                                                                <td className="text-center">{ toDateTimeString(item.timestamp) }</td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                }) }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="6">
                                                <div className='h-100'>
                                                    <div className="card-header">
                                                        <button className="btn btn-success btn-sm" onClick={ addNewAppeal }><i className="fas fa-plus"></i> Add</button>
                                                    </div>
                                                    <div className="p-0">
                                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                                            <thead className="bg-200 text-900">
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Contact Type</th>
                                                                    <th>Contact Source</th>
                                                                    <th>Date Received</th>
                                                                    <th className="text-center">Status</th>
                                                                    <th className="text-center">Actions</th>
                                                                </tr>
                                                            </thead>
                                                            { !arrayUtilities.isNullOrEmpty(appeals) &&
                                                                <tbody>
                                                                    { appeals.map((appeal) => {
                                                                        var appealUrl = "/organisation/" + props.organisationId + "/breach/" + breachId + "/appeal/" + appeal.id;
                                                                        return (
                                                                            <>
                                                                                <tr>
                                                                                    <td><Link to={ appealUrl }><h6 className="my-0">{ stringHelpers.contactDetailsName(appeal.contactDetails) }</h6></Link></td>
                                                                                    <td>{ Enums.ContactTypes[appeal.contactDetails.contactType] }</td>
                                                                                    <td>{ Enums.ContactSource[appeal.contactDetails.contactSource] }</td>
                                                                                    <td>{ toDateTimeString(appeal.timestamp) } ({timeAgo(appeal.timestamp)})
                                                                                    </td>
                                                                                    <td className="text-center">

                                                                                        { appeal.appealStatus === 0 &&
                                                                                            <span className="badge badge rounded-pill badge-warning">{ Enums.AppealStatus[appeal.appealStatus] }</span>
                                                                                        }
                                                                                        { appeal.appealStatus === 1 &&
                                                                                            <span className="badge badge rounded-pill badge-success">{ Enums.AppealStatus[appeal.appealStatus] }</span>
                                                                                        }
                                                                                        { appeal.appealStatus === 2 &&
                                                                                            <span className="badge badge rounded-pill badge-danger">{ Enums.AppealStatus[appeal.appealStatus] }</span>
                                                                                        }
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                        <button className="btn btn-falcon-default btn-sm dropdown-toggle py-2 mr-3 dropdown-caret-none m-auto" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button>
                                                                                        <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                                                                            <Link to={ appealUrl } type="button" className="dropdown-item btn-sm"><div className="icon-container"><i className="fas fa-envelope"></i></div> View Details</Link>
                                                                                            <button type="button" className="dropdown-item btn-sm" data-toggle="modal" data-target={ `#delete-appeal-${ appeal.id }` }><i className="fas fa-times"></i> Delete Appeal</button>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                                <div className="modal fade" id={ `delete-appeal-${ appeal.id }` } tabIndex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
                                                                                    <div className="modal-dialog" role="document">
                                                                                        <div className="modal-content">
                                                                                            <div className="modal-header">
                                                                                                <h5 className="modal-title" id="deleteModalLabel">Are you sure you want to delete this appeal?</h5>
                                                                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                                                    <span aria-hidden="true">&times;</span>
                                                                                                </button>
                                                                                            </div>
                                                                                            <div className='modal-body'>
                                                                                                <p>Deleting an appeal is permenant, and won't affect the breach status</p>
                                                                                            </div>
                                                                                            <div className="modal-footer">
                                                                                                <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                                                                <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal" onClick={ () => deleteAppeal(appeal.id) }>
                                                                                                    Delete</button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    }) }
                                                                </tbody>
                                                            }
                                                        </table>
                                                    </div>
                                                </div>
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="7">
                                                <div className='h-100'>
                                                    <div className="card-header">
                                                        <button className="btn btn-success btn-sm" onClick={ addNewTransfer }><i className="fas fa-plus"></i> Add</button>
                                                    </div>
                                                    <div className="p-0">
                                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                                            <thead className="bg-200 text-900">
                                                                <tr>
                                                                    <th>Notifier</th>
                                                                    <th>Liable Party</th>
                                                                    <th>Contact Type</th>
                                                                    <th>Contact Source</th>
                                                                    <th className="text-center">Date/Time</th>
                                                                    <th>Status</th>
                                                                    <th className="text-center">Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                { !arrayUtilities.isNullOrEmpty(transfers)
                                                                    && transfers.map(transfer => {
                                                                        const transferUrl = `/organisation/${ props.organisationId }/breach/${ breachId }/transfer-of-liability/${ transfer.id }`
                                                                        return <tr>
                                                                            <td><Link to={ transferUrl }><h6 className="my-0">{ stringHelpers.contactDetailsName(transfer.liabilityNotifierContact) }</h6></Link></td>
                                                                            <td><Link to={ transferUrl }><h6 className="my-0">{ stringHelpers.contactDetailsName(transfer.liabilityPartyContact) }</h6></Link></td>
                                                                            <td>{ Enums.ContactTypes[transfer.liabilityNotifierContact.contactType] }</td>
                                                                            <td>{ Enums.ContactSource[transfer.liabilityNotifierContact.contactSource] }</td>
                                                                            <td className="text-center">{ toDateTimeString(transfer.liabilityNotifierContact.timestamp) } - {timeAgo(transfer.liabilityNotifierContact.timestamp)}</td>
                                                                            <td>{ Enums.TransferOfLiabilityStatus[transfer.transferOfLiabilityStatus] }</td>
                                                                            <td className="text-center">
                                                                                <button className="btn btn-falcon-default btn-sm dropdown-toggle py-2 mr-3 dropdown-caret-none m-auto" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button>
                                                                                <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                                                                    <Link to={ transferUrl } type="button" className="dropdown-item btn-sm"><div className="icon-container"><i className="fas fa-envelope"></i></div> View Details</Link>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    })

                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="8">
                                                <div className='h-100'>
                                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <div className='card-header'>
                                                        <button className="btn btn-success btn-sm" onClick={ () => setShowAddPayment(true) }><i className="fas fa-plus"></i> Add</button>
                                                    </div>}
                                                    <div className="p-0">
                                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                                            <thead className="bg-200 text-900">
                                                                <tr>
                                                                    <th>Date/Time</th>
                                                                    <th>Amount</th>
                                                                    <th>Payment Provider</th>
                                                                    <th>Reference</th>
                                                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <th>&nbsp;</th>}
                                                                </tr>
                                                            </thead>
                                                            {
                                                                <tbody>
                                                                    {
                                                                        navItems[8].isLoading
                                                                            ? <tr><td><Loader /></td></tr>
                                                                            : !arrayUtilities.isNullOrEmpty(breachPayments) && breachPayments.map((breachPayment) =>
                                                                                <tr className={ breachPayment.isDeleted ? 'text-decoration-line-through text-muted' : '' }>
                                                                                    <td>{ toDateTimeString(breachPayment.timestamp) } </td>
                                                                                    <td>£{ breachPayment.amount.toFixed(2) }</td>
                                                                                    <td>{ Enums.PaymentProvider[breachPayment.paymentProvider] }</td>
                                                                                    <td>{ breachPayment.paymentProviderId }</td>
                                                                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <td className='text-right'>
                                                                                        {
                                                                                            !breachPayment.isDeleted &&
                                                                                            <button onClick={ () => { setBreachPaymentId(breachPayment.id); setShowDeletePayment(true); } } className='btn p-0'><i className="fas fa-trash-alt"></i></button>
                                                                                        }
                                                                                    </td>}
                                                                                </tr>
                                                                            ) }
                                                                </tbody>
                                                            }
                                                        </table>
                                                    </div>
                                                    <Modal show={ showAddPayment } size="lg">
                                                        <Modal.Header>
                                                            <Modal.Title>
                                                                Add a payment
                                                            </Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Body>
                                                            <div className="row">
                                                                <div className="col-12 ">
                                                                    <p className="font-weight-semi-bold  mt-1 mb-2">Amount:</p>
                                                                </div>
                                                                <div className="col-12">
                                                                    <div className="form-group mb-0">
                                                                        <input className="form-control" type='number' step="0.01" value={ paymentAmount } onChange={ (e) => setPaymentAmount(e.target.value) } />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 ">
                                                                    <p className="font-weight-semi-bold  mt-1 mb-2">Reference:</p>
                                                                </div>
                                                                <div className="col-12">
                                                                    <div className="form-group mb-0">
                                                                        <input className="form-control" type='text' value={ paymentReference } onChange={ (e) => setPaymentReference(e.target.value) } />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 ">
                                                                    <p className="font-weight-semi-bold  mt-1 mb-2">Note:</p>
                                                                </div>
                                                                <div className="col-12">
                                                                    <div className="form-group mb-0">
                                                                        <textarea rows={ 3 } className="form-control" value={ paymentNote } onChange={ (e) => setPaymentNote(e.target.value) } />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Modal.Body>
                                                        <Modal.Footer>
                                                            <button className="btn btn-sm btn-danger mt-1" onClick={ () => setShowAddPayment(false) }>Cancel</button>
                                                            <button className="btn btn-sm btn-success mt-1" disabled={ !canSavePayment } onClick={ savePayment }>Save</button>
                                                        </Modal.Footer>
                                                    </Modal>

                                                    <Modal show={ showDeletePayment } size="lg">
                                                        <Modal.Header>
                                                            <Modal.Title>
                                                                Are you sure you want to delete this payment?
                                                            </Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Footer>
                                                            <button className="btn btn-falcon-default btn-sm mt-1" onClick={ () => setShowDeletePayment(false) }>Cancel</button>
                                                            <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal"
                                                                onClick={ () => {
                                                                    Api.deleteBreachPayment(
                                                                        props.organisationId, breachId, breachPaymentId, props.token,
                                                                        () => {
                                                                            setShowDeletePayment(false);
                                                                            getBreach();
                                                                        },
                                                                        error => console.log(error),
                                                                    )
                                                                } }
                                                            >
                                                                Delete
                                                            </button>
                                                        </Modal.Footer>
                                                    </Modal>
                                                </div>

                                            </Tab.Pane>
                                            <Tab.Pane eventKey="9">
                                                <div className='h-100'>
                                                    {(roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) || isThirdPartyUser || roleUtilities.isOrganisationProcessor(props.user, props.organisationId)) && 
                                                    <div className='card-header'>
                                                        <button className="btn btn-success btn-sm" onClick={ () => {
                                                            setAdditionalChargeAmount("")
                                                            setAdditionalChargeDescription("")
                                                            setShowAddCharge(true)
                                                        } }><i className="fas fa-plus"></i> Add</button>
                                                    </div>}
                                                    <div className="p-0">
                                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                                            <thead className="bg-200 text-900">
                                                                <tr>
                                                                    <th>Date/Time</th>
                                                                    <th>Amount</th>
                                                                    <th>Description</th>
                                                                    <th>&nbsp;</th>
                                                                </tr>
                                                            </thead>
                                                            {
                                                                <tbody>
                                                                    {
                                                                        navItems[9].isLoading
                                                                            ? <tr><td><Loader /></td></tr>
                                                                            : !arrayUtilities.isNullOrEmpty(additionalCharges) && additionalCharges.map(charge =>
                                                                                <tr>
                                                                                    <td>{ toDateTimeString(charge.timestamp) } </td>
                                                                                    <td>£{ charge.amount.toFixed(2) }</td>
                                                                                    <td>{ charge.description }</td>
                                                                                    {(roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) || isThirdPartyUser || roleUtilities.isOrganisationProcessor(props.user, props.organisationId)) && <td className='text-right pr-3'>
                                                                                        <button onClick={ () => { 
                                                                                            setAdditionalChargeId(charge.id); 
                                                                                            setAdditionalChargeAmount(String(charge.amount))
                                                                                            setAdditionalChargeDescription(charge.description)
                                                                                            setShowAddCharge(true); 
                                                                                        } } className='btn p-0 mr-1'><i className="far fa-edit"></i></button>
                                                                                        <button onClick={ () => { setAdditionalChargeId(charge.id); setShowDeleteCharge(true); } } className='btn p-0'><i className="fas fa-trash-alt"></i></button>
                                                                                    </td>}
                                                                                </tr>
                                                                            ) }
                                                                </tbody>
                                                            }
                                                        </table>
                                                    </div>
                                                    <Modal show={ showAddCharge } size="lg">
                                                        <Modal.Header>
                                                            <Modal.Title>
                                                                Add an Additional Charge
                                                            </Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Body>
                                                            <div className="row">
                                                                <div className="col-12 ">
                                                                    <p className="font-weight-semi-bold  mt-1 mb-2">Amount:</p>
                                                                </div>
                                                                <div className="col-12">
                                                                    <div className="form-group mb-0">
                                                                        <input className="form-control" type='number' step="0.01" value={ additionalChargeAmount } onChange={ (e) => setAdditionalChargeAmount(e.target.value) } />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 ">
                                                                    <p className="font-weight-semi-bold  mt-1 mb-2">Description:</p>
                                                                </div>
                                                                <div className="col-12">
                                                                    <div className="form-group mb-0">
                                                                        <textarea rows={ 3 } className="form-control" value={ additionalChargeDescription } onChange={ (e) => setAdditionalChargeDescription(e.target.value) } />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Modal.Body>
                                                        <Modal.Footer>
                                                            <button className="btn btn-sm btn-danger mt-1" onClick={ () => {
                                                                setAdditionalChargeAmount("")
                                                                setAdditionalChargeDescription("")
                                                                setShowAddCharge(false)
                                                            } }>Cancel</button>
                                                            <button className="btn btn-sm btn-success mt-1" disabled={ stringHelpers.isNullOrEmpty(additionalChargeAmount) } onClick={ saveAdditionalCharge }>Save</button>
                                                        </Modal.Footer>
                                                    </Modal>

                                                    <Modal show={ showDeleteCharge } size="md">
                                                        <Modal.Header>
                                                            <Modal.Title>
                                                                Delete additional charge
                                                            </Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Body>
                                                            Are you sure you want to delete this additional charge?
                                                        </Modal.Body>
                                                        <Modal.Footer>
                                                            <button className="btn btn-falcon-default btn-sm mt-1" onClick={ () => setShowDeleteCharge(false) }>Cancel</button>
                                                            <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal"
                                                                onClick={ () => {
                                                                    Api.deleteAdditionalCharge(
                                                                        data => {
                                                                            if (data.isError) {
                                                                                setShowDeleteCharge(false);
                                                                                setErrorMessage(data.errorMessage)
                                                                            } else {
                                                                                setShowDeleteCharge(false);
                                                                                getAdditionalCharges();
                                                                                getBreach()
                                                                            }
                                                                        },
                                                                        error => {
                                                                            console.log(error)
                                                                            setShowDeleteCharge(false);
                                                                            setErrorMessage(error.message)
                                                                        },
                                                                        breachId, additionalChargeId, props.organisationId, props.token,
                                                                    )
                                                                } }
                                                            >
                                                                Delete
                                                            </button>
                                                        </Modal.Footer>
                                                    </Modal>
                                                </div>

                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </div>
                                </>
                                : <BreachOldLayout 
                                    breachId={props.match.params.breachId} 
                                    organisationId={props.organisationId}
                                    token={props.token}
                                    user={props.user}
                                    sites={props.sites}
                                />
                                }
                                
                            </div>
                        </div>
                    </div>
                </div>
            </> }
            {
                !stringHelpers.isNullOrEmpty(errorMessage) &&
                <ErrorModal
                    message={ errorMessage }
                    onHide={ () => setErrorMessage(null) }
                />
            }
        </>
    )
}
export default Breach;

